"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const fp_1 = require("lodash/fp");
const lodash_1 = __importDefault(require("lodash"));
const utils_1 = require("./utils");
const ui_1 = __importDefault(require("./ui"));
const whitelist_1 = __importDefault(require("./whitelist"));
// @HACK: Temp backwards compatibility (we should update where CONTACT gets used to use new .UI version)
const { CONTACT } = ui_1.default;
const AHM_SOURCE_CODE = 'I09000';
const CLAIMS_HISTORY = { PAGE_SIZE_IN_YEARS: 1 };
const CLAIM_ITEMS_LIMIT = 20;
const CLAIM_STATUS = {
    APPROVED: 'approved',
    PROVIDER_NOT_APPROVED: 'provider-not-approved',
    MEMBERSHIP_UNDER_INVESTIGATION: 'membership-under-investigation',
    PROVIDER_INVALID: 'provider-invalid',
    DECLINED: 'declined',
    CARD_NUMBER_INVALID: 'card-number-invalid',
    NO_ACTION_TAKEN: 'no-action-taken',
    MEMBERSHIP_NOT_COVERED: 'membership-not-covered',
    MEMBERSHIP_TERMINATED_OR_SUSPENDED_AT_DATE_OF_SERVICE: 'membership-terminated-or-suspended-at-date-of-service',
    MEMBERSHIP_UNFINANCIAL: 'membership-unfinancial',
    CARD_HAS_EXPIRED: 'card-has-expired',
    NO_ANCILLARY_COVER: 'no-ancillary-cover',
    PROVIDER_NOT_REGISTERED: 'provider-not-registered',
    BENEFIT_LIMIT_EXCEEDED: 'benefit-limit-exceeded',
    CANNOT_MAP_ERROR: 'cannot-map-error',
    HEALTH_WARNING_PREVENTING_CLAIM_SUBMISSION: 'health-warning-preventing-claim-submission',
    DATABASE_ERROR: 'database-error',
    ERROR_READING_MEMBER_DETAILS: 'error-reading-member-details',
    NETCLAIM_LIMIT_REACHED: 'netclaim-limit-reached',
    NO_POLICY_DETAILS: 'no-policy-details',
    TRANS_AMOUNT_NOT_EQUAL_CLAIM_LINE_AMOUNTS: 'trans-amount-not-equal-claim-line-amounts',
    DAILY_LIMIT_NOT_DEFINED: 'daily-limit-not-defined',
    NETCLAIM_GREATER_THAN_28_DAYS: 'netclaim-greater-than-28-days',
    SUSPENDED: 'suspended',
    UNKNOWN: 'unknown',
};
const CLAIM_ITEM_STATUS = {
    APPROVED: 'approved',
    NO_BENEFIT_PAYABLE: 'no-benefit-payable',
    NO_BENEFIT_RESTRICTED: 'no-benefit-restricted',
    REDUCED_BENEFIT_RESTRICTED: 'reduced-benefit-restricted',
    NO_BENEFIT_PREVIOUSLY_PAID: 'no-benefit-previously-paid',
    NO_BENEFIT_LIMIT_REACHED: 'no-benefit-limit-reached',
    REDUCED_BENEFIT_LIMIT_REACHED: 'reduced-benefit-limit-reached',
    NO_BENEFIT_QUALIFYING_PERIOD_APPLIES: 'no-benefit-qualifying-period-applies',
    NO_BENEFIT_PRE_REQUISITE_SERVICE_APPLIES: 'no-benefit-pre-requisite-service-applies',
    NO_BENEFIT_PRE_EXISTING_AILMENT: 'no-benefit-pre-existing-ailment',
    ITEM_NUMBER_INVALID: 'item-number-invalid',
    ITEM_NUMBER_CEASED: 'item-number-ceased',
    ITEM_NOT_VALID_FOR_PROVIDER: 'item-not-valid-for-provider',
    ITEM_NOT_APPROVED_NOT_PAYABLE: 'item-not-approved-not-payable',
    SERVICE_EXCEEDS_NUMBER_OF_TIMES_PERMITTED: 'service-exceeds-number-of-times-permitted',
    COST_REQUIRED: 'cost-required',
    DATE_OF_SERVICE_AFTER_MAX: 'date-of-service-after-max',
    DATE_OF_SERVICE_BEFORE_MIN: 'date-of-service-before-min',
    MEMBER_NOT_COVERED: 'member-not-covered',
    DEPENDANT_STATUS_CEASED: 'dependant-status-ceased',
    INVALID_PATIENT_NO: 'invalid-patient-no',
    EXPIRED_CARD: 'expired-card',
    MEMBERSHIP_NOT_COVERED: 'membership-not-covered',
    MEMBERSHIP_TERMINATED_OR_SUSPENDED_AT_DATE_OF_SERVICE: 'membership-terminated-or-suspended-at-date-of-service',
    MEMBERSHIP_UNFINANCIAL: 'membership-unfinancial',
    NO_ANCILLARY_COVER: 'no-ancillary-cover',
    NOT_COVERED_FOR_SERVICE: 'not-covered-for-service',
    NOT_APPLICABLE_MEMBER_AGE: 'not-applicable-member-age',
    NOT_APPLICABLE_MEMBER_GENDER: 'not-applicable-member-gender',
    INVALID_TOOTH_ID: 'invalid-tooth-id',
    INVALID_PROVIDER: 'invalid-provider',
    TRANSACTION_FAILED: 'transaction-failed',
    CANNOT_MAP_ERROR: 'cannot-map-error',
    HEALTH_POLICY_WARNING: 'health-policy-warning',
    ITEM_NOT_PAYABLE_WITH_SELECTED_COMBINATION: 'item-not-payable-with-selected-combination',
    NETCLAIM_LIMIT_REACHED: 'netclaim-limit-reached',
    SUSPENDED: 'suspended',
    NOT_ESTABLISHED_DUE_TO_TP4: 'not-established-due-to-tp4',
    DAILY_LIMIT_NOT_DEFINED: 'daily-limit-not-defined',
    NETCLAIM_GREATER_THAN_28_DAYS: 'netclaim-greater-than-28-days',
    NO_BENEFIT_PBS: 'no-benefit-pbs',
    RECEIPT_REQUIRED: 'receipt-required',
    UNKNOWN: 'unknown',
};
const CLAIM_ITEM_TYPE = {
    ANCILLARY: 'ancillary',
    DENTAL: 'dental',
    FED: 'fed',
    FRIENDLY_SOCIETY: 'friendly-society',
    HOSPITAL: 'hospital',
    ILLNESS: 'illness',
    LIMIT: 'limit',
    MEDICAL: 'medical',
    TRAVEL_INSURANCE: 'travel-insurance',
};
const CLAIM_TYPE = {
    ACCESS_GAP: 'access-gap',
    ACCESS_GAP_MANUAL: 'access-gap-manual',
    CLINIC_DENTAL: 'clinic-dental',
    CLINIC_EYECARE: 'clinic-eyecare',
    COUNTER: 'counter',
    HEALTHPOINT: 'healthpoint',
    HICAPS: 'hicaps',
    HICAPS_AUTO_PAID: 'hicaps-auto-paid',
    HOSPITAL_ELECTRONIC_DATA_INTERCHANGE: 'hospital-electronic-data-interchange',
    ECLIPSE_HOSPITAL_INPATIENT_HOSPITAL_CLAIMING: 'eclipse-hospital-inpatient-hospital-claiming',
    ECLIPSE_25_PERCENT_GAP_BILLING_AGENT_AND_PATIENT: 'eclipse-25-percent-gap-billing-agent-and-patient',
    ECLIPSE_SCHEME_AND_AGREEMENT: 'eclipse-scheme-and-agreement',
    ECLIPSE_TWO_WAY: 'eclipse-two-way',
    MAIL: 'mail',
    MEDICAL_NETCLAIM_BULK: 'medical-netclaim-bulk',
    PREVIOUS_FUND: 'previous-fund',
    REMOTE_LOCATION: 'remote-location',
    SIMPLIFIED_BILL: 'simplified-bill',
    TELECLAIM: 'teleclaim',
    TELECLAIM_RESOLVED: 'teleclaim-resolved',
    TWO_WAY: 'two-way',
    WEB: 'web',
    WEB_RESOLVED: 'web-resolved',
};
const CLAIM_METHOD_BY_DISPLAY = {
    'ahm Clinic': [CLAIM_TYPE.CLINIC_DENTAL, CLAIM_TYPE.CLINIC_EYECARE],
    'At Hospital': [
        CLAIM_TYPE.ECLIPSE_HOSPITAL_INPATIENT_HOSPITAL_CLAIMING,
        CLAIM_TYPE.HOSPITAL_ELECTRONIC_DATA_INTERCHANGE,
    ],
    Counter: [CLAIM_TYPE.COUNTER],
    GapCover: [CLAIM_TYPE.ACCESS_GAP_MANUAL, CLAIM_TYPE.ACCESS_GAP, CLAIM_TYPE.ECLIPSE_SCHEME_AND_AGREEMENT],
    HealthPoint: [CLAIM_TYPE.HEALTHPOINT],
    HICAPS: [CLAIM_TYPE.HICAPS_AUTO_PAID, CLAIM_TYPE.HICAPS],
    Mail: [CLAIM_TYPE.MAIL, CLAIM_TYPE.REMOTE_LOCATION],
    Medical: [CLAIM_TYPE.MEDICAL_NETCLAIM_BULK],
    'Medicare Two-Way': [
        CLAIM_TYPE.ECLIPSE_25_PERCENT_GAP_BILLING_AGENT_AND_PATIENT,
        CLAIM_TYPE.ECLIPSE_TWO_WAY,
        CLAIM_TYPE.SIMPLIFIED_BILL,
        CLAIM_TYPE.TWO_WAY,
    ],
    Phone: [CLAIM_TYPE.TELECLAIM_RESOLVED, CLAIM_TYPE.TELECLAIM],
    'Previous fund': [CLAIM_TYPE.PREVIOUS_FUND],
    Web: [CLAIM_TYPE.WEB_RESOLVED, CLAIM_TYPE.WEB],
};
const CLAIM_PAYMENT_STATUS = {
    APPROVED: 'approved', // Payment has been approved - Yet to be paid out
    DECLINED: 'declined',
    NIL_BENEFIT: 'nil-benefit', // Typically means the claim was not eligible for payment
    NO_PAYMENT: 'no-payment', // Typically means the claim was an adjustment which didn't require payment
    PAID: 'paid',
    PENDING: 'pending', // Typically means claim has been processed but payment not yet issued
    SUSPENDED: 'suspended', // This means that ahm is waiting on something from the customer
    PARTIALLY_APPROVED: 'partially-approved', // This means the claim has been paid with some declined items
};
const FUND = {
    AHM: 'ahm',
    FUND14: 'fund-14',
    AHM_OSHC: 'ahm-oshc', // ahm Overseas Student Health Cover
    MEDIBANK_OSHC: 'medibank-oshc', // Medibank Overseas Student Health Cover
    AHM_RECIPROCAL_COUNTRY_VISITOR: 'ahm-reciprocal-country-visitor', // Yellow medicare card
    AHM_TEMPORARY_RESIDENT: 'ahm-temporary-resident', // Blue medicare card (no one should still be on this fund)
    AHM_ONE_BIG_SWITCH: 'ahm-one-big-switch', // One Big Switch get 10% discount
    KOGAN: 'kogan', // Kogan Partnership
};
const MEDICARE_CARD_COLOUR = {
    BLUE: 'blue',
    GREEN: 'green',
    YELLOW: 'yellow',
};
const RATE_TYPE = {
    CURRENT: 'current',
    PREVIOUS: 'previous',
    BOTH: 'both',
    OTHER: 'other',
};
const RATE_CODE = {
    DEFAULT: 'default',
    PARTIAL_PREMIUM_ASSISTANCE_COVID_50_PERCENT: 'partial-premium-assistance-covid-50-percent',
};
const RATE_CODE_VALUE = {
    [RATE_CODE.PARTIAL_PREMIUM_ASSISTANCE_COVID_50_PERCENT]: '50%',
};
const ANALYTICS = {
    DIMENSIONS: {
        AGE_BRACKET: '10',
        AGENT_ID: '32',
        CAMPAIGN_ID: '33',
        CLIENT_ID: '31',
        CONVERSATION_ID: '34',
        DAYS_SINCE_JOIN: '49',
        ENGAGEMENT_ID: '35',
        FREQUENCY: '11',
        HOSPITAL_TIER: '5',
        INCOME: '18',
        INCOME_TIER: '12',
        INCOME_TYPE: '13',
        IP_ADDRESS: '1',
        MEMBERSHIP_ID: '29',
        MEMBERSHIP_NEW_OR_EXISTING: '21',
        PAYMENT_METHOD: '54',
        PRODUCT_ID: '7',
        PRODUCT_NAME: '8',
        PRODUCT_TYPE: '9',
        PROMO_CODE_0: '24',
        PROMO_CODE_1: '26',
        PROMO_CODE_2: '27',
        PROMO_CODE_3: '28',
        REBATE: '14',
        SCALE: '15',
        SKILL_NAME: '37',
        STATE: '16',
        SWITCHING: '17',
        VISITOR_ID: '36',
    },
    EVENTS: {
        ECOMMERCE: {
            ADD_IMPRESSION: 'addImpression',
            ADD_PRODUCT: 'addProduct',
            SET_ACTION: 'setAction',
        },
        ECOMMERCE_GA4: {
            ADD_PAYMENT_INFO: 'add_payment_info',
            ADD_TO_CART: 'add_to_cart',
            BEGIN_CHECKOUT: 'begin_checkout',
            CALCULATE_BENEFIT: 'calculate_benefit',
            CHANGE_EXCESS: 'change_excess',
            CHANGE_PAYMENT_METHOD: 'change_payment_method',
            CHANGE_PAYMENT_SCHEDULE: 'change_payment_schedule',
            COMPLETED_COVER_CHANGE: 'completed_cover_change',
            COPY_REFER_A_FRIEND_CODE: 'copy_refer_a_friend_code',
            FIND_PROVIDER: 'find_provider',
            GENERATE_LEAD: 'generate_lead',
            LOGIN: 'login',
            MEMBER_PAYMENT_COMPLETED: 'member_payment_completed',
            MEMBER_PAYMENT_UNSUCCESSFUL: 'member_payment_unsuccessful',
            ON_PAGE_CHAT: 'on_page_chat',
            PURCHASE: 'purchase',
            REQUEST_A_CALLBACK: 'request_a_callback',
            REVIEW_AGR: 'review_agr',
            REVIEW_PAYMENT_COVER_CHANGE: 'review_payment_cover_change',
            SELECTED_COVER_CHANGE_TO_PAY: 'selected_cover_change_to_pay',
            START_CLAIM: 'start_claim',
            SUBMIT_CLAIM: 'submit_claim',
            SUCCESSFUL_FORM_SUBMIT: 'successful_form_submit',
            UNSUCCESSFUL_FORM_SUBMIT: 'unsuccessful_form_submit',
            UNSUCCESSFUL_LOGIN: 'unsuccessful_login',
            UPLOAD_DOCUMENT: 'upload_document',
            USER_INTERACTION: 'user_interaction',
            VIEW_ITEM_LIST: 'view_item_list',
            VIEW_ITEM: 'view_item',
            VIEWED_EXPERIMENT: 'viewed_experiment',
        },
        LOGIN: 'login',
    },
    GA4_DIMENSIONS: {
        AGE_BRACKET: 'age_bracket',
        AGENT_ID: 'agent_id',
        CAMPAIGN_ID: 'campaign_id',
        CONVERSATION_ID: 'conversation_id',
        CLIENT_ID: 'client_id',
        DAYS_SINCE_JOIN: 'days_since_join',
        ENGAGEMENT_ID: 'engagement_id',
        HOSPITAL_TIER: 'hospital_tier',
        INCOME: 'income',
        INCOME_TIER: 'income_tier',
        INCOME_TYPE: 'income_type',
        ITEM_ID: 'item_id',
        ITEM_NAME: 'item_name',
        IP_ADDRESS: 'ip_address',
        MEMBERSHIP_ID: 'membership_id',
        MEMBERSHIP_NEW_OR_EXISTING: 'membership_new_or_existing',
        PAYMENT_FREQUENCY: 'payment_frequency',
        PAYMENT_METHOD: 'payment_method',
        PRODUCT_ID: 'product_id',
        PRODUCT_NAME: 'product_name',
        PRODUCT_TYPE: 'product_type',
        PROMO_CODE_0: 'promo_code_0',
        PROMO_CODE_1: 'promo_code_1',
        PROMO_CODE_2: 'promo_code_2',
        PROMO_CODE_3: 'promo_code_3',
        REBATE: 'rebate',
        SCALE: 'scale',
        SKILL_NAME: 'skill_name',
        STATE: 'state',
        SWITCHING: 'switching',
        VISITOR_ID: 'visitor_id',
    },
    VALUES: {
        NULL: ' ', // analytics requires single space when there is a null/undefined value
    },
};
const UPLOAD_DOCUMENT_TYPES = {
    ACCIDENT_CLAIM_FORM: 'AccidentClaimForm',
    CLAIM_FORM: 'ClaimForm',
    COCHLEAR_SPEECH_PROCESSOR_REPLACEMENT: 'CochlearSpeechProcessorReplacement',
    DEATH_CERTIFICATES: 'DeathCertificates',
    DIRECT_DEBIT_FORMS: 'DirectDebitForms',
    FINANCIAL_HARDSHIP_FORM: 'FinancialHardshipForm',
    HEALTH_IMPROVEMENT_BENEFIT_APPROVAL_FORM: 'HealthImprovementBenefitApprovalForm',
    HOSPITAL_COVER_CHECK_FORM: 'HospitalCoverCheckForm',
    INSULIN_PUMP_REPLACEMENT_FORM: 'InsulinPumpReplacementForm',
    MEDICARE_ELIGIBILITY_LETTERS: 'MedicareEligibilityLetters',
    NPS_REQUEST_A_CALL_FEEDBACK_FORM: 'NpsRequestACallFeedbackForm',
    PAUSE_COVER: 'PauseCover',
    PENSION_CARDS: 'PensionCards',
    POWER_OF_ATTORNEY: 'PowerOfAttorney',
    PRE_EXISTING_CONDITION: 'PreExistingCondition',
    REBATE_APPLICATION: 'RebateApplication',
    TERMINATION_REQUESTS: 'TerminationRequests',
    THIRD_PARTY_AUTHORITY: '3rdPartyAuthority',
    TRANSFER_CERTIFICATES: 'TransferCertificates',
    UNEMPLOYMENT_SUSPENSION: 'UnemploymentSuspension',
};
const STATE = {
    ACT: 'australian-capital-territory',
    NSW: 'new-south-wales',
    QLD: 'queensland',
    SA: 'south-australia',
    TAS: 'tasmania',
    VIC: 'victoria',
    WA: 'western-australia',
    NT: 'northern-territory',
};
const ADDRESS_STATE = STATE;
const PRODUCT_FETCH_TYPE = {
    SPECIFIC: 'specific',
    ALL: 'all',
};
const SCALE = {
    SINGLE: 'single',
    SINGLE_PARENT: 'single-parent',
    SINGLE_PARENT_PLUS_21: 'single-parent-plus-21',
    COUPLE: 'couple',
    FAMILY: 'family',
    FAMILY_PLUS_21: 'family-plus-21',
};
const LIFE_STAGE = {
    YOUNG_ADULT: 'young-adult', // <=34
    MIDDLE_AGE: 'middle-age', // 35-54
    OLDER_ADULTS: 'older-adults', // 55-69
    ELDERLY_ADULTS: 'elderly-adults', // 70+
    // These are not referenced but are included for completeness
    // YOUNG_FAMILY: 'young-family', // Family with youngest child under 5
    // SETTLED_FAMILY: 'settled-family', // Family with youngest child over 5
};
const INCOME_TIER = {
    TIER_0: '0',
    TIER_1: '1',
    TIER_2: '2',
    TIER_3: '3',
};
const REBATE_OPTION = {
    YES: true,
    NO: false,
    // BOTH: 'Both', we are unlikely to use Both
};
const SURCHARGE_INDICATOR = {
    YES: true,
    NO: false,
};
const SURCHARGE_PERCENTAGE = 0.21;
const REBATE_AGE_BRACKET = {
    BRACKET_0: '0',
    BRACKET_1: '1',
    BRACKET_2: '2',
};
const INCOME_TYPE = {
    SINGLE: 'single',
    COUPLE: 'couple',
};
const AGR_TABLE = {
    '2018-04-01': {
        [REBATE_AGE_BRACKET.BRACKET_0]: {
            [INCOME_TIER.TIER_0]: '25.415',
            [INCOME_TIER.TIER_1]: '16.943',
            [INCOME_TIER.TIER_2]: '8.471',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_1]: {
            [INCOME_TIER.TIER_0]: '29.651',
            [INCOME_TIER.TIER_1]: '21.180',
            [INCOME_TIER.TIER_2]: '12.707',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_2]: {
            [INCOME_TIER.TIER_0]: '33.887',
            [INCOME_TIER.TIER_1]: '25.415',
            [INCOME_TIER.TIER_2]: '16.943',
            [INCOME_TIER.TIER_3]: '0',
        },
    },
    '2019-04-01': {
        [REBATE_AGE_BRACKET.BRACKET_0]: {
            [INCOME_TIER.TIER_0]: '25.059',
            [INCOME_TIER.TIER_1]: '16.706',
            [INCOME_TIER.TIER_2]: '8.352',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_1]: {
            [INCOME_TIER.TIER_0]: '29.236',
            [INCOME_TIER.TIER_1]: '20.883',
            [INCOME_TIER.TIER_2]: '12.529',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_2]: {
            [INCOME_TIER.TIER_0]: '33.413',
            [INCOME_TIER.TIER_1]: '25.059',
            [INCOME_TIER.TIER_2]: '16.706',
            [INCOME_TIER.TIER_3]: '0',
        },
    },
    '2020-04-01': {
        [REBATE_AGE_BRACKET.BRACKET_0]: {
            [INCOME_TIER.TIER_0]: '25.059',
            [INCOME_TIER.TIER_1]: '16.706',
            [INCOME_TIER.TIER_2]: '8.352',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_1]: {
            [INCOME_TIER.TIER_0]: '29.236',
            [INCOME_TIER.TIER_1]: '20.883',
            [INCOME_TIER.TIER_2]: '12.529',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_2]: {
            [INCOME_TIER.TIER_0]: '33.413',
            [INCOME_TIER.TIER_1]: '25.059',
            [INCOME_TIER.TIER_2]: '16.706',
            [INCOME_TIER.TIER_3]: '0',
        },
    },
    '2020-10-01': {
        [REBATE_AGE_BRACKET.BRACKET_0]: {
            [INCOME_TIER.TIER_0]: '25.059',
            [INCOME_TIER.TIER_1]: '16.706',
            [INCOME_TIER.TIER_2]: '8.352',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_1]: {
            [INCOME_TIER.TIER_0]: '29.236',
            [INCOME_TIER.TIER_1]: '20.883',
            [INCOME_TIER.TIER_2]: '12.529',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_2]: {
            [INCOME_TIER.TIER_0]: '33.413',
            [INCOME_TIER.TIER_1]: '25.059',
            [INCOME_TIER.TIER_2]: '16.706',
            [INCOME_TIER.TIER_3]: '0',
        },
    },
    '2021-04-01': {
        [REBATE_AGE_BRACKET.BRACKET_0]: {
            [INCOME_TIER.TIER_0]: '24.608',
            [INCOME_TIER.TIER_1]: '16.405',
            [INCOME_TIER.TIER_2]: '8.202',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_1]: {
            [INCOME_TIER.TIER_0]: '28.710',
            [INCOME_TIER.TIER_1]: '20.507',
            [INCOME_TIER.TIER_2]: '12.303',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_2]: {
            [INCOME_TIER.TIER_0]: '32.812',
            [INCOME_TIER.TIER_1]: '24.608',
            [INCOME_TIER.TIER_2]: '16.405',
            [INCOME_TIER.TIER_3]: '0',
        },
    },
    '2022-04-01': {
        [REBATE_AGE_BRACKET.BRACKET_0]: {
            [INCOME_TIER.TIER_0]: '24.608',
            [INCOME_TIER.TIER_1]: '16.405',
            [INCOME_TIER.TIER_2]: '8.202',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_1]: {
            [INCOME_TIER.TIER_0]: '28.710',
            [INCOME_TIER.TIER_1]: '20.507',
            [INCOME_TIER.TIER_2]: '12.303',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_2]: {
            [INCOME_TIER.TIER_0]: '32.812',
            [INCOME_TIER.TIER_1]: '24.608',
            [INCOME_TIER.TIER_2]: '16.405',
            [INCOME_TIER.TIER_3]: '0',
        },
    },
    '2022-11-01': {
        [REBATE_AGE_BRACKET.BRACKET_0]: {
            [INCOME_TIER.TIER_0]: '24.608',
            [INCOME_TIER.TIER_1]: '16.405',
            [INCOME_TIER.TIER_2]: '8.202',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_1]: {
            [INCOME_TIER.TIER_0]: '28.710',
            [INCOME_TIER.TIER_1]: '20.507',
            [INCOME_TIER.TIER_2]: '12.303',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_2]: {
            [INCOME_TIER.TIER_0]: '32.812',
            [INCOME_TIER.TIER_1]: '24.608',
            [INCOME_TIER.TIER_2]: '16.405',
            [INCOME_TIER.TIER_3]: '0',
        },
    },
    '2023-01-16': {
        [REBATE_AGE_BRACKET.BRACKET_0]: {
            [INCOME_TIER.TIER_0]: '24.608',
            [INCOME_TIER.TIER_1]: '16.405',
            [INCOME_TIER.TIER_2]: '8.202',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_1]: {
            [INCOME_TIER.TIER_0]: '28.710',
            [INCOME_TIER.TIER_1]: '20.507',
            [INCOME_TIER.TIER_2]: '12.303',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_2]: {
            [INCOME_TIER.TIER_0]: '32.812',
            [INCOME_TIER.TIER_1]: '24.608',
            [INCOME_TIER.TIER_2]: '16.405',
            [INCOME_TIER.TIER_3]: '0',
        },
    },
    '2023-06-01': {
        [REBATE_AGE_BRACKET.BRACKET_0]: {
            [INCOME_TIER.TIER_0]: '24.608',
            [INCOME_TIER.TIER_1]: '16.405',
            [INCOME_TIER.TIER_2]: '8.202',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_1]: {
            [INCOME_TIER.TIER_0]: '28.710',
            [INCOME_TIER.TIER_1]: '20.507',
            [INCOME_TIER.TIER_2]: '12.303',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_2]: {
            [INCOME_TIER.TIER_0]: '32.812',
            [INCOME_TIER.TIER_1]: '24.608',
            [INCOME_TIER.TIER_2]: '16.405',
            [INCOME_TIER.TIER_3]: '0',
        },
    },
    '2024-04-01': {
        [REBATE_AGE_BRACKET.BRACKET_0]: {
            [INCOME_TIER.TIER_0]: '24.608',
            [INCOME_TIER.TIER_1]: '16.405',
            [INCOME_TIER.TIER_2]: '8.202',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_1]: {
            [INCOME_TIER.TIER_0]: '28.710',
            [INCOME_TIER.TIER_1]: '20.507',
            [INCOME_TIER.TIER_2]: '12.303',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_2]: {
            [INCOME_TIER.TIER_0]: '32.812',
            [INCOME_TIER.TIER_1]: '24.608',
            [INCOME_TIER.TIER_2]: '16.405',
            [INCOME_TIER.TIER_3]: '0',
        },
    },
    '2025-04-01': {
        [REBATE_AGE_BRACKET.BRACKET_0]: {
            [INCOME_TIER.TIER_0]: '24.288',
            [INCOME_TIER.TIER_1]: '16.192',
            [INCOME_TIER.TIER_2]: '8.095',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_1]: {
            [INCOME_TIER.TIER_0]: '28.337',
            [INCOME_TIER.TIER_1]: '20.240',
            [INCOME_TIER.TIER_2]: '12.143',
            [INCOME_TIER.TIER_3]: '0',
        },
        [REBATE_AGE_BRACKET.BRACKET_2]: {
            [INCOME_TIER.TIER_0]: '32.385',
            [INCOME_TIER.TIER_1]: '24.288',
            [INCOME_TIER.TIER_2]: '16.192',
            [INCOME_TIER.TIER_3]: '0',
        },
    },
};
const PAYMENT_FREQUENCY = {
    WEEKLY: 'weekly',
    FORTNIGHTLY: 'fortnightly',
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly',
    HALF_YEARLY: 'half-yearly',
    YEARLY: 'yearly',
};
const PAYMENT_FREQUENCY_DURATION = {
    [PAYMENT_FREQUENCY.WEEKLY]: [1, 'weeks'],
    [PAYMENT_FREQUENCY.FORTNIGHTLY]: [2, 'weeks'],
    [PAYMENT_FREQUENCY.MONTHLY]: [1, 'months'],
    [PAYMENT_FREQUENCY.QUARTERLY]: [3, 'months'],
    [PAYMENT_FREQUENCY.HALF_YEARLY]: [6, 'months'],
    [PAYMENT_FREQUENCY.YEARLY]: [1, 'years'],
};
const PARENT_PRODUCT = {
    AMBULANCE_BASIC: 'ambulance-basic',
    AMBULANCE_AND_ACCIDENT_BASIC: 'ambulance-and-accident-basic',
    BOOST_BASIC_PLUS: 'boost-basic-plus',
    BOOST_FLEXI_BASIC_PLUS: 'boost-flexi-basic-plus',
    BOOST_PACKAGE_BASIC_PLUS: 'boost-package-basic-plus',
    BUDGET_BRONZE_PLUS: 'budget-bronze-plus',
    CLASSIC_FLEXI_SILVER_PLUS: 'classic-flexi-silver-plus',
    CLASSIC_PACKAGE_SILVER_PLUS: 'classic-package-silver-plus',
    CLASSIC_SAVER_SILVER_PLUS: 'classic-saver-silver-plus',
    CLASSIC_SILVER_PLUS: 'classic-silver-plus',
    CORE_BRONZE_PLUS: 'core-bronze-plus',
    CORE_HOSPITAL_BASIC_PLUS: 'core-hospital-basic-plus',
    CORE_SILVER_PLUS: 'core-silver-plus',
    DELUXE_FLEXI_SILVER_PLUS: 'deluxe-flexi-silver-plus',
    DELUXE_PACKAGE_SILVER_PLUS: 'deluxe-package-silver-plus',
    DELUXE_SAVER_SILVER_PLUS: 'deluxe-saver-silver-plus',
    DELUXE_SILVER_PLUS: 'deluxe-silver-plus',
    ELEVATE_SILVER_PLUS: 'elevate-silver-plus',
    ESSENTIALS_BASIC_PLUS: 'essentials-basic-plus',
    ESSENTIALS_FLEXI_BASIC_PLUS: 'essentials-flexi-basic-plus',
    ESSENTIALS_PACKAGE_BASIC_PLUS: 'essentials-package-basic-plus',
    ESSENTIALS_SILVER_PLUS: 'essentials-silver-plus',
    FIRST_STEP_BRONZE_PLUS: 'first-step-bronze-plus',
    ACCESS_FLEXI_BASIC: 'access-flexi-basic',
    LITE_50_BASIC_PLUS: 'lite-50-basic-plus',
    LITE_60_BASIC_PLUS: 'lite-60-basic-plus',
    LITE_BRONZE_PLUS: 'lite-bronze-plus',
    LITE_FLEXI_BRONZE_PLUS: 'lite-flexi-bronze-plus',
    LITE_PACKAGE_BRONZE_PLUS: 'lite-package-bronze-plus',
    PREMIUM_SILVER_PLUS: 'premium-silver-plus',
    STANDARD_COVER_SILVER_PLUS: 'standard-cover-silver-plus',
    STARTER_BASIC: 'starter-basic',
    STARTER_BRONZE: 'starter-bronze',
    STARTER_FLEXI_BASIC: 'starter-flexi-basic',
    STARTER_PACKAGE_BASIC: 'starter-package-basic',
    STARTER_SILVER: 'starter-silver',
    SUPER_SILVER_PLUS: 'super-silver-plus',
    TOP_HOSPITAL_GOLD: 'top-hospital-gold',
    TOP_HOSPITAL_PACKAGE_GOLD: 'top-hospital-package-gold',
    ADVANCED_HOSPITAL_GOLD: 'advanced-hospital-gold',
    SIMPLE_BRONZE_PLUS: 'simple-bronze-plus',
};
const PRODUCT_TYPE = {
    AMBULANCE: 'ambulance',
    EXTRAS: 'extras',
    HOSPITAL: 'hospital',
    PACKAGE: 'package',
    COMBINED: 'combined',
};
const PRODUCT_TYPE_SLUG = {
    COMBINED: 'hospital-extras-bundle',
    EXTRAS: 'extras-cover',
    HOSPITAL: 'hospital-cover',
    PACKAGE: 'hospital-extras-packages',
};
const EXTRAS_TYPE = {
    CHOOSABLE: 'choosable',
};
const PACKAGE_PRODUCTS = {
    BOOST_FLEXI_BASIC_PLUS_EXCESS_500: 'boost-flexi-basic-plus-excess-500',
    BOOST_FLEXI_BASIC_PLUS_EXCESS_750: 'boost-flexi-basic-plus-excess-750',
    BOOST_PACKAGE_BASIC_PLUS_EXCESS_500: 'boost-package-basic-plus-excess-500',
    BOOST_PACKAGE_BASIC_PLUS_EXCESS_750: 'boost-package-basic-plus-excess-750',
    CLASSIC_FLEXI_SILVER_PLUS_EXCESS_500: 'classic-flexi-silver-plus-excess-500',
    CLASSIC_FLEXI_SILVER_PLUS_EXCESS_750: 'classic-flexi-silver-plus-excess-750',
    CLASSIC_PACKAGE_SILVER_PLUS_EXCESS_500: 'classic-package-silver-plus-excess-500',
    CLASSIC_PACKAGE_SILVER_PLUS_EXCESS_750: 'classic-package-silver-plus-excess-750',
    DELUXE_FLEXI_SILVER_PLUS_EXCESS_500: 'deluxe-flexi-silver-plus-excess-500',
    DELUXE_FLEXI_SILVER_PLUS_EXCESS_750: 'deluxe-flexi-silver-plus-excess-750',
    DELUXE_PACKAGE_SILVER_PLUS_EXCESS_500: 'deluxe-package-silver-plus-excess-500',
    DELUXE_PACKAGE_SILVER_PLUS_EXCESS_750: 'deluxe-package-silver-plus-excess-750',
    ESSENTIALS_FLEXI_BASIC_PLUS_EXCESS_0: 'essentials-flexi-basic-plus-excess-0',
    ESSENTIALS_FLEXI_BASIC_PLUS_EXCESS_750: 'essentials-flexi-basic-plus-excess-750',
    ESSENTIALS_PACKAGE_BASIC_PLUS_EXCESS_0: 'essentials-package-basic-plus-excess-0',
    ESSENTIALS_PACKAGE_BASIC_PLUS_EXCESS_750: 'essentials-package-basic-plus-excess-750',
    FIRST_STEP_BRONZE_PLUS_EXCESS_500: 'first-step-bronze-plus-excess-500',
    FIRST_STEP_BRONZE_PLUS_EXCESS_750: 'first-step-bronze-plus-excess-750',
    ACCESS_FLEXI_BASIC_EXCESS_500: 'access-flexi-basic-excess-500',
    ACCESS_FLEXI_BASIC_EXCESS_750: 'access-flexi-basic-excess-750',
    LITE_50_BASIC_PLUS_EXCESS_500: 'lite-50-basic-plus-excess-500',
    LITE_50_BASIC_PLUS_EXCESS_750: 'lite-50-basic-plus-excess-750',
    LITE_60_BASIC_PLUS_EXCESS_500: 'lite-60-basic-plus-excess-500',
    LITE_60_BASIC_PLUS_EXCESS_750: 'lite-60-basic-plus-excess-750',
    LITE_FLEXI_BRONZE_PLUS_EXCESS_500: 'lite-flexi-bronze-plus-excess-500',
    LITE_FLEXI_BRONZE_PLUS_EXCESS_750: 'lite-flexi-bronze-plus-excess-750',
    LITE_PACKAGE_BRONZE_PLUS_EXCESS_500: 'lite-package-bronze-plus-excess-500',
    LITE_PACKAGE_BRONZE_PLUS_EXCESS_750: 'lite-package-bronze-plus-excess-750',
    STANDARD_COVER_SILVER_PLUS_EXCESS_500: 'standard-cover-silver-plus-excess-500',
    STANDARD_COVER_SILVER_PLUS_EXCESS_750: 'standard-cover-silver-plus-excess-750',
    STARTER_FLEXI_BASIC_EXCESS_500: 'starter-flexi-basic-excess-500',
    STARTER_FLEXI_BASIC_EXCESS_750: 'starter-flexi-basic-excess-750',
    STARTER_PACKAGE_BASIC_EXCESS_500: 'starter-package-basic-excess-500',
    STARTER_PACKAGE_BASIC_EXCESS_750: 'starter-package-basic-excess-750',
    TOP_HOSPITAL_PACKAGE_GOLD_COPAY_0: 'top-hospital-package-gold-copay-0',
    TOP_HOSPITAL_PACKAGE_GOLD_COPAY_500: 'top-hospital-package-gold-copay-500',
};
const EXTRAS_PRODUCTS = {
    BLACK_50_EXTRAS: 'black-50-extras',
    BLACK_50_SAVER_EXTRAS: 'black-50-saver-extras',
    BLACK_60_EXTRAS: 'black-60-extras',
    BLACK_70_BOOST_EXTRAS: 'black-70-boost-extras',
    BLACK_70_EXTRAS: 'black-70-extras',
    CHOOSABLE_50_TEETH: 'choosable-50-teeth',
    CHOOSABLE_60_TEETH_EYES: 'choosable-60-teeth-eyes',
    CHOOSABLE_60_TEETH_MUSCLE_BONE: 'choosable-60-teeth-muscle-bone',
    CHOOSABLE_60_TEETH_WELLBEING: 'choosable-60-teeth-wellbeing',
    CHOOSABLE_60_TEETH_EYES_MUSCLE_BONE: 'choosable-60-teeth-eyes-muscle-bone',
    CHOOSABLE_60_TEETH_EYES_WELLBEING: 'choosable-60-teeth-eyes-wellbeing',
    CHOOSABLE_60_TEETH_WELLBEING_MUSCLE_BONE: 'choosable-60-teeth-wellbeing-muscle-bone',
    CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE: 'choosable-60-teeth-eyes-wellbeing-muscle-bone',
    CLASSIC_EXTRAS: 'classic-extras',
    FAMILY_EXTRAS: 'family-extras',
    FLEX_50_EXTRAS: 'flex-50-extras',
    FLEX_60_EXTRAS: 'flex-60-extras',
    LIFESTYLE_EXTRAS: 'lifestyle-extras',
    SUPER_EXTRAS: 'super-extras',
    VALUE_EXTRAS: 'value-extras',
};
const HOSPITAL_PRODUCTS = {
    AMBULANCE_BASIC_EXCESS_750: 'ambulance-basic-excess-750',
    AMBULANCE_AND_ACCIDENT_BASIC_EXCESS_500: 'ambulance-and-accident-basic-excess-500',
    AMBULANCE_AND_ACCIDENT_BASIC_EXCESS_750: 'ambulance-and-accident-basic-excess-750',
    BOOST_BASIC_PLUS_EXCESS_500: 'boost-basic-plus-excess-500',
    BOOST_BASIC_PLUS_EXCESS_750: 'boost-basic-plus-excess-750',
    BUDGET_BRONZE_PLUS_EXCESS_500: 'budget-bronze-plus-excess-500',
    BUDGET_BRONZE_PLUS_EXCESS_750: 'budget-bronze-plus-excess-750',
    CLASSIC_SAVER_SILVER_PLUS_EXCESS_500: 'classic-saver-silver-plus-excess-500',
    CORE_BRONZE_PLUS_EXCESS_500: 'core-bronze-plus-excess-500',
    CORE_BRONZE_PLUS_EXCESS_750: 'core-bronze-plus-excess-750',
    CORE_HOSPITAL_BASIC_PLUS_EXCESS_500: 'core-hospital-basic-plus-excess-500',
    CORE_HOSPITAL_BASIC_PLUS_EXCESS_750: 'core-hospital-basic-plus-excess-750',
    CORE_SILVER_PLUS_EXCESS_500: 'core-silver-plus-excess-500',
    CORE_SILVER_PLUS_EXCESS_750: 'core-silver-plus-excess-750',
    DELUXE_SAVER_SILVER_PLUS_EXCESS_500: 'deluxe-saver-silver-plus-excess-500',
    ELEVATE_SILVER_PLUS_EXCESS_500: 'elevate-silver-plus-excess-500',
    ELEVATE_SILVER_PLUS_EXCESS_750: 'elevate-silver-plus-excess-750',
    ESSENTIALS_BASIC_PLUS_EXCESS_0: 'essentials-basic-plus-excess-0',
    ESSENTIALS_BASIC_PLUS_EXCESS_750: 'essentials-basic-plus-excess-750',
    ESSENTIALS_SILVER_PLUS_EXCESS_500: 'essentials-silver-plus-excess-500',
    ESSENTIALS_SILVER_PLUS_EXCESS_750: 'essentials-silver-plus-excess-750',
    LITE_BRONZE_PLUS_EXCESS_500: 'lite-bronze-plus-excess-500',
    LITE_BRONZE_PLUS_EXCESS_750: 'lite-bronze-plus-excess-750',
    PREMIUM_SILVER_PLUS_COPAY_250: 'premium-silver-plus-copay-250',
    STARTER_BASIC_EXCESS_500: 'starter-basic-excess-500',
    STARTER_BASIC_EXCESS_750: 'starter-basic-excess-750',
    STARTER_BRONZE_EXCESS_500: 'starter-bronze-excess-500',
    STARTER_BRONZE_EXCESS_750: 'starter-bronze-excess-750',
    STARTER_SILVER_EXCESS_500: 'starter-silver-excess-500',
    STARTER_SILVER_EXCESS_750: 'starter-silver-excess-750',
    SUPER_SILVER_PLUS_EXCESS_500: 'super-silver-plus-excess-500',
    SUPER_SILVER_PLUS_EXCESS_750: 'super-silver-plus-excess-750',
    TOP_HOSPITAL_GOLD_COPAY_500: 'top-hospital-gold-copay-500',
    TOP_HOSPITAL_GOLD_COPAY_800: 'top-hospital-gold-copay-800',
    TOP_HOSPITAL_GOLD_EXCESS_0: 'top-hospital-gold-excess-0',
    TOP_HOSPITAL_GOLD_EXCESS_500: 'top-hospital-gold-excess-500',
    TOP_HOSPITAL_GOLD_EXCESS_750: 'top-hospital-gold-excess-750',
    ADVANCED_HOSPITAL_GOLD_EXCESS_0: 'advanced-hospital-gold-excess-0',
    ADVANCED_HOSPITAL_GOLD_EXCESS_500: 'advanced-hospital-gold-excess-500',
    ADVANCED_HOSPITAL_GOLD_EXCESS_750: 'advanced-hospital-gold-excess-750',
    SIMPLE_BRONZE_PLUS_EXCESS_500: 'simple-bronze-plus-excess-500',
    SIMPLE_BRONZE_PLUS_EXCESS_750: 'simple-bronze-plus-excess-750',
};
const AMBULANCE_PRODUCTS = {
    AMBULANCE: 'ambulance',
};
const PRODUCT_BY_TYPE_DICT = {
    [PRODUCT_TYPE.PACKAGE]: PACKAGE_PRODUCTS,
    [PRODUCT_TYPE.EXTRAS]: EXTRAS_PRODUCTS,
    [PRODUCT_TYPE.HOSPITAL]: HOSPITAL_PRODUCTS,
    [PRODUCT_TYPE.AMBULANCE]: AMBULANCE_PRODUCTS,
    [PRODUCT_TYPE.COMBINED]: (0, utils_1.getCombinations)(HOSPITAL_PRODUCTS, EXTRAS_PRODUCTS),
};
const COMBINED_PRODUCT_COMPONENTS = (0, utils_1.getCombinationsWithComponents)(PRODUCT_BY_TYPE_DICT[PRODUCT_TYPE.HOSPITAL], PRODUCT_BY_TYPE_DICT[PRODUCT_TYPE.EXTRAS]);
const PRODUCT = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, PACKAGE_PRODUCTS), EXTRAS_PRODUCTS), HOSPITAL_PRODUCTS), AMBULANCE_PRODUCTS), (0, utils_1.getCombinations)(HOSPITAL_PRODUCTS, EXTRAS_PRODUCTS));
// Group the products by type so behaviour can be altered depending on type
// PRODUCTS_BY_TYPE is written once here and then translated into ahm-whics automatically
const PRODUCTS_BY_TYPE = lodash_1.default.mapValues(PRODUCT_BY_TYPE_DICT, lodash_1.default.values);
const PRODUCTS_BY_PARENT = {
    [PARENT_PRODUCT.AMBULANCE_BASIC]: [PRODUCT.AMBULANCE_BASIC_EXCESS_750],
    [PARENT_PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC]: [
        PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC_EXCESS_500,
        PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC_EXCESS_750,
    ],
    [PARENT_PRODUCT.BOOST_BASIC_PLUS]: [PRODUCT.BOOST_BASIC_PLUS_EXCESS_500, PRODUCT.BOOST_BASIC_PLUS_EXCESS_750],
    [PARENT_PRODUCT.BOOST_FLEXI_BASIC_PLUS]: [
        PRODUCT.BOOST_FLEXI_BASIC_PLUS_EXCESS_500,
        PRODUCT.BOOST_FLEXI_BASIC_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.BOOST_PACKAGE_BASIC_PLUS]: [
        PRODUCT.BOOST_PACKAGE_BASIC_PLUS_EXCESS_500,
        PRODUCT.BOOST_PACKAGE_BASIC_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.BUDGET_BRONZE_PLUS]: [PRODUCT.BUDGET_BRONZE_PLUS_EXCESS_500, PRODUCT.BUDGET_BRONZE_PLUS_EXCESS_750],
    [PARENT_PRODUCT.CLASSIC_FLEXI_SILVER_PLUS]: [
        PRODUCT.CLASSIC_FLEXI_SILVER_PLUS_EXCESS_500,
        PRODUCT.CLASSIC_FLEXI_SILVER_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.CLASSIC_PACKAGE_SILVER_PLUS]: [
        PRODUCT.CLASSIC_PACKAGE_SILVER_PLUS_EXCESS_500,
        PRODUCT.CLASSIC_PACKAGE_SILVER_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.CLASSIC_SAVER_SILVER_PLUS]: [PRODUCT.CLASSIC_SAVER_SILVER_PLUS_EXCESS_500],
    [PARENT_PRODUCT.CORE_BRONZE_PLUS]: [PRODUCT.CORE_BRONZE_PLUS_EXCESS_500, PRODUCT.CORE_BRONZE_PLUS_EXCESS_750],
    [PARENT_PRODUCT.CORE_HOSPITAL_BASIC_PLUS]: [
        PRODUCT.CORE_HOSPITAL_BASIC_PLUS_EXCESS_500,
        PRODUCT.CORE_HOSPITAL_BASIC_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.CORE_SILVER_PLUS]: [PRODUCT.CORE_SILVER_PLUS_EXCESS_500, PRODUCT.CORE_SILVER_PLUS_EXCESS_750],
    [PARENT_PRODUCT.DELUXE_FLEXI_SILVER_PLUS]: [
        PRODUCT.DELUXE_FLEXI_SILVER_PLUS_EXCESS_500,
        PRODUCT.DELUXE_FLEXI_SILVER_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.DELUXE_PACKAGE_SILVER_PLUS]: [
        PRODUCT.DELUXE_PACKAGE_SILVER_PLUS_EXCESS_500,
        PRODUCT.DELUXE_PACKAGE_SILVER_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.DELUXE_SAVER_SILVER_PLUS]: [PRODUCT.DELUXE_SAVER_SILVER_PLUS_EXCESS_500],
    [PARENT_PRODUCT.ELEVATE_SILVER_PLUS]: [
        PRODUCT.ELEVATE_SILVER_PLUS_EXCESS_500,
        PRODUCT.ELEVATE_SILVER_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.ESSENTIALS_BASIC_PLUS]: [
        PRODUCT.ESSENTIALS_BASIC_PLUS_EXCESS_0,
        PRODUCT.ESSENTIALS_BASIC_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.ESSENTIALS_FLEXI_BASIC_PLUS]: [
        PRODUCT.ESSENTIALS_FLEXI_BASIC_PLUS_EXCESS_0,
        PRODUCT.ESSENTIALS_FLEXI_BASIC_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.ESSENTIALS_PACKAGE_BASIC_PLUS]: [
        PRODUCT.ESSENTIALS_PACKAGE_BASIC_PLUS_EXCESS_0,
        PRODUCT.ESSENTIALS_PACKAGE_BASIC_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.ESSENTIALS_SILVER_PLUS]: [
        PRODUCT.ESSENTIALS_SILVER_PLUS_EXCESS_500,
        PRODUCT.ESSENTIALS_SILVER_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.FIRST_STEP_BRONZE_PLUS]: [
        PRODUCT.FIRST_STEP_BRONZE_PLUS_EXCESS_500,
        PRODUCT.FIRST_STEP_BRONZE_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.ACCESS_FLEXI_BASIC]: [PRODUCT.ACCESS_FLEXI_BASIC_EXCESS_500, PRODUCT.ACCESS_FLEXI_BASIC_EXCESS_750],
    [PARENT_PRODUCT.LITE_50_BASIC_PLUS]: [PRODUCT.LITE_50_BASIC_PLUS_EXCESS_500, PRODUCT.LITE_50_BASIC_PLUS_EXCESS_750],
    [PARENT_PRODUCT.LITE_60_BASIC_PLUS]: [PRODUCT.LITE_60_BASIC_PLUS_EXCESS_500, PRODUCT.LITE_60_BASIC_PLUS_EXCESS_750],
    [PARENT_PRODUCT.LITE_BRONZE_PLUS]: [PRODUCT.LITE_BRONZE_PLUS_EXCESS_500, PRODUCT.LITE_BRONZE_PLUS_EXCESS_750],
    [PARENT_PRODUCT.LITE_FLEXI_BRONZE_PLUS]: [
        PRODUCT.LITE_FLEXI_BRONZE_PLUS_EXCESS_500,
        PRODUCT.LITE_FLEXI_BRONZE_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.LITE_PACKAGE_BRONZE_PLUS]: [
        PRODUCT.LITE_PACKAGE_BRONZE_PLUS_EXCESS_500,
        PRODUCT.LITE_PACKAGE_BRONZE_PLUS_EXCESS_750,
    ],
    // This constant was referring to a nonexistent value, and previously read:
    // [PARENT_PRODUCT.PREMIUM_SILVER_PLUS]: [PRODUCT.PREMIUM_SILVER_PLUS_EXCESS_500],
    [PARENT_PRODUCT.STANDARD_COVER_SILVER_PLUS]: [
        PRODUCT.STANDARD_COVER_SILVER_PLUS_EXCESS_500,
        PRODUCT.STANDARD_COVER_SILVER_PLUS_EXCESS_750,
    ],
    [PARENT_PRODUCT.STARTER_BASIC]: [PRODUCT.STARTER_BASIC_EXCESS_500, PRODUCT.STARTER_BASIC_EXCESS_750],
    [PARENT_PRODUCT.STARTER_BRONZE]: [PRODUCT.STARTER_BRONZE_EXCESS_500, PRODUCT.STARTER_BRONZE_EXCESS_750],
    [PARENT_PRODUCT.STARTER_FLEXI_BASIC]: [
        PRODUCT.STARTER_FLEXI_BASIC_EXCESS_500,
        PRODUCT.STARTER_FLEXI_BASIC_EXCESS_750,
    ],
    [PARENT_PRODUCT.STARTER_PACKAGE_BASIC]: [
        PRODUCT.STARTER_PACKAGE_BASIC_EXCESS_500,
        PRODUCT.STARTER_PACKAGE_BASIC_EXCESS_750,
    ],
    [PARENT_PRODUCT.STARTER_SILVER]: [PRODUCT.STARTER_SILVER_EXCESS_500, PRODUCT.STARTER_SILVER_EXCESS_750],
    [PARENT_PRODUCT.SUPER_SILVER_PLUS]: [PRODUCT.SUPER_SILVER_PLUS_EXCESS_500, PRODUCT.SUPER_SILVER_PLUS_EXCESS_750],
    [PARENT_PRODUCT.TOP_HOSPITAL_GOLD]: [
        PRODUCT.TOP_HOSPITAL_GOLD_COPAY_800,
        PRODUCT.TOP_HOSPITAL_GOLD_EXCESS_0,
        PRODUCT.TOP_HOSPITAL_GOLD_EXCESS_500,
        PRODUCT.TOP_HOSPITAL_GOLD_EXCESS_750,
        PRODUCT.TOP_HOSPITAL_GOLD_COPAY_500,
    ],
    [PARENT_PRODUCT.TOP_HOSPITAL_PACKAGE_GOLD]: [
        PRODUCT.TOP_HOSPITAL_PACKAGE_GOLD_COPAY_500,
        PRODUCT.TOP_HOSPITAL_PACKAGE_GOLD_COPAY_0,
    ],
    [PARENT_PRODUCT.ADVANCED_HOSPITAL_GOLD]: [
        PRODUCT.ADVANCED_HOSPITAL_GOLD_EXCESS_0,
        PRODUCT.ADVANCED_HOSPITAL_GOLD_EXCESS_500,
        PRODUCT.ADVANCED_HOSPITAL_GOLD_EXCESS_750,
    ],
    [PARENT_PRODUCT.SIMPLE_BRONZE_PLUS]: [PRODUCT.SIMPLE_BRONZE_PLUS_EXCESS_500, PRODUCT.SIMPLE_BRONZE_PLUS_EXCESS_750],
};
const PARENT_PRODUCT_BY_TYPE = (0, fp_1.reduce)((result, productName) => {
    const productSample = (0, fp_1.get)(`${productName}.[0]`, PRODUCTS_BY_PARENT); // boost-basic-plus-excess-500
    const productType = (0, fp_1.findKey)((0, fp_1.includes)(productSample), PRODUCTS_BY_TYPE); // hospital
    if (productType === undefined) {
        return result;
    }
    const parentProductSet = lodash_1.default.get(result, productType, []); // accumulator['hospital']
    return Object.assign(Object.assign({}, result), { [productType]: [...parentProductSet, productName] });
}, Object.values(PRODUCT_TYPE).reduce((result, productType) => (Object.assign(Object.assign({}, result), { [productType]: [] })), {}), PARENT_PRODUCT);
const COMBINED_PARENT_PRODUCT_COMPONENTS = (0, utils_1.getCombinationsWithComponents)(PARENT_PRODUCT_BY_TYPE[PRODUCT_TYPE.HOSPITAL], PRODUCT_BY_TYPE_DICT[PRODUCT_TYPE.EXTRAS]);
const SERVICE_TYPE = {
    EXTRAS: 'extras',
    HOSPITAL: 'hospital',
};
const PRODUCT_ITEM_CATEGORY = {
    SERVICE: 'service',
    FEATURE: 'feature',
};
const FEATURE = {
    DEPENDANT_0_EXCESS: 'dependant-0-excess',
    INCREASED_LIMITS: 'increased-limits',
    LOYALTY_BONUS: 'loyalty-bonus',
    NO_FAMILY_LIMITS: 'no-family-limits',
    NO_OBSTETRICS: 'no-obstetrics',
};
const OFFER_GROUP = {
    DEFAULT: 'default',
    ACCOMPANYING: 'accompanying',
    EXCLUSIVE: 'exclusive',
};
const SERVICE = {
    // Extras
    ACUPUNCTURE: 'acupuncture',
    ALTERNATIVE_THERAPY: 'alternative-therapy',
    AUDIOLOGY: 'audiology',
    BASIC_DENTAL: 'basic-dental',
    CHINESE_MEDICINE: 'chinese-medicine',
    CHIROPRACTIC: 'chiropractic',
    COMPLEX_DENTAL: 'complex-dental',
    COUNSELLING: 'counselling',
    DIETETICS: 'dietetics',
    EMERGENCY_AMBULANCE: 'emergency-ambulance',
    EXERCISE_PHYSIOLOGY: 'exercise-physiology',
    EYE_THERAPY: 'eye-therapy',
    GENERAL_DENTAL: 'general-dental',
    HEALTH_IMPROVEMENT: 'health-improvement',
    HEARING_AIDS: 'hearing-aids',
    HIGH_COST_DENTAL: 'high-cost-dental',
    HYPNOTHERAPY: 'hypnotherapy',
    JOINT_FLUID_INJECTIONS: 'joint-fluid-injections',
    LASER_EYE_SURGERY: 'laser-eye-surgery',
    MAJOR_DENTAL: 'major-dental',
    MEDICAL_GASES: 'medical-gases',
    MYOTHERAPY: 'myotherapy',
    NATURAL_THERAPY: 'natural-therapy',
    NUTRITION: 'nutrition',
    OCCUPATIONAL_THERAPY: 'occupational-therapy',
    OPTICAL: 'optical',
    ORTHODONTICS: 'orthodontics',
    ORTHOPTICS: 'orthoptics',
    ORTHOTICS: 'orthotics',
    OSTEOPATHY: 'osteopathy',
    OUTPATIENT: 'outpatient',
    PHARMACY: 'pharmacy',
    PHYSIOTHERAPY: 'physiotherapy',
    PODIATRY: 'podiatry',
    POST_OPERATIVE_MEDICAL_AIDS: 'post-operative-medical-aids',
    PRE_POST_NATAL: 'pre-post-natal',
    PSYCHOLOGY_HYPNOTHERAPY: 'psychology-hypnotherapy',
    PSYCHOLOGY: 'psychology',
    REMEDIAL_MASSAGE: 'remedial-massage',
    ROUTINE_DENTAL: 'routine-dental',
    SPEECH_THERAPY: 'speech-therapy',
    TRAVEL_ACCOMMODATION: 'travel-accommodation',
    WEIGHT_LOSS: 'weight-loss',
    // Hospital
    ACCIDENT_SERVICES: 'accident-services',
    AMBULANCE_SERVICES: 'ambulance-services',
    APPENDIX_REMOVAL: 'appendix-removal',
    BACK_SURGERY: 'back-surgery',
    BOWEL_SURGERY: 'bowel-surgery',
    BRAIN_SURGERY: 'brain-surgery',
    CANCER_THERAPIES: 'cancer-therapies',
    CANCER_TREATMENT: 'cancer-treatment',
    COLONOSCOPIES: 'colonoscopies',
    CONTRACEPTIVE_PROCEDURES_VASECTOMY: 'contraceptive-procedures-vasectomy',
    DIALYSIS: 'dialysis',
    GROMMETS: 'grommets',
    GYNAECOLOGY: 'gynaecology',
    HEART_RELATED_PROCEDURES: 'heart-related-procedures',
    HYSTERECTOMY: 'hysterectomy',
    JOINT_RECONSTRUCTIONS: 'joint-reconstructions',
    JOINT_REPLACEMENTS_ALL: 'joint-replacements-all',
    JOINT_REPLACEMENTS_EXCEPT_HIPS_KNEES: 'joint-replacements-except-hips-knees',
    JOINT_REPLACEMENTS_HIPS_KNEES: 'joint-replacements-hips-knees',
    LABOUR_WARD: 'labour-ward',
    MAJOR_EYE_SURGERY: 'major-eye-surgery',
    MEDICARE_COVERED_SERVICES: 'medicare-covered-services',
    MIDWIFE: 'midwife',
    NERVE_PAIN_TREATMENT: 'nerve-pain-treatment',
    OBESITY_SURGERY: 'obesity-surgery',
    OBSTETRICS: 'obstetrics',
    PALLIATIVE_CARE: 'palliative-care',
    PLASTIC_RECONSTRUCTIVE_SURGERY: 'plastic-reconstructive-surgery',
    PSYCHIATRIC_SERVICES: 'psychiatric-services',
    REHABILITATION: 'rehabilitation',
    REPRODUCTIVE_SERVICES: 'reproductive-services',
    SPEECH_PROCESSOR_INSULIN_PUMP_REPLACEMENTS: 'speech-processor-insulin-pump-replacements',
    SPINAL_FUSION: 'spinal-fusion',
    STERILITY_REVERSAL: 'sterility-reversal',
    TENS_MACHINE: 'tens-machine',
    TONSILS_REMOVAL: 'tonsils-removal',
    VASCULAR_VARICOSE_VEIN_SURGERY: 'vascular-varicose-vein-surgery',
    WEIGHT_LOSS_SURGERY: 'weight-loss-surgery',
    WISDOM_TEETH_REMOVAL: 'wisdom-teeth-removal',
    // PHI Reform hospital services
    // New product services which will replace the old ones on 2019-10-01
    // PHIR prefix to be removed after
    PHIR_ASSISTED_REPRODUCTIVE_SERVICES: 'phir-assisted-reproductive-services',
    PHIR_BACK_NECK_SPINE: 'phir-back-neck-spine',
    PHIR_BLOOD: 'phir-blood',
    PHIR_BONE_JOINT_MUSCLE: 'phir-bone-joint-muscle',
    PHIR_BRAIN_NERVOUS_SYSTEM: 'phir-brain-nervous-system',
    PHIR_BREAST_SURGERY: 'phir-breast-surgery',
    PHIR_CATARACTS: 'phir-cataracts',
    PHIR_CHEMOTHERAPY_RADIOTHERAPY_IMMUNOTHERAPY_FOR_CANCER: 'phir-chemotherapy-radiotherapy-immunotherapy-for-cancer',
    PHIR_DENTAL_SURGERY: 'phir-dental-surgery',
    PHIR_DIABETES_MANAGEMENT: 'phir-diabetes-management',
    PHIR_DIALYSIS_FOR_CHRONIC_KIDNEY_FAILURE: 'phir-dialysis-for-chronic-kidney-failure',
    PHIR_DIGESTIVE_SYSTEM: 'phir-digestive-system',
    PHIR_EAR_NOSE_THROAT: 'phir-ear-nose-throat',
    PHIR_EYE: 'phir-eye',
    PHIR_GASTROINTESTINAL_ENDOSCOPY: 'phir-gastrointestinal-endoscopy',
    PHIR_GYNAECOLOGY: 'phir-gynaecology',
    PHIR_HEART_VASCULAR_SYSTEM: 'phir-heart-vascular-system',
    PHIR_HERNIA_APPENDIX: 'phir-hernia-appendix',
    PHIR_HOSPITAL_PSYCHIATRIC_SERVICES: 'phir-hospital-psychiatric-services',
    PHIR_IMPLANTATION_OF_HEARING_DEVICES: 'phir-implantation-of-hearing-devices',
    PHIR_INSULIN_PUMPS: 'phir-insulin-pumps',
    PHIR_JOINT_RECONSTRUCTIONS: 'phir-joint-reconstructions',
    PHIR_JOINT_REPLACEMENTS: 'phir-joint-replacements',
    PHIR_KIDNEY_BLADDER: 'phir-kidney-bladder',
    PHIR_LUNG_CHEST: 'phir-lung-chest',
    PHIR_MALE_REPRODUCTIVE_SYSTEM: 'phir-male-reproductive-system',
    PHIR_MISCARRIAGE_TERMINATION_OF_PREGNANCY: 'phir-miscarriage-termination-of-pregnancy',
    PHIR_PAIN_MANAGEMENT_WITH_DEVICE: 'phir-pain-management-with-device',
    PHIR_PAIN_MANAGEMENT: 'phir-pain-management',
    PHIR_PALLIATIVE_CARE: 'phir-palliative-care',
    PHIR_PLASTIC_RECONSTRUCTIVE_SURGERY: 'phir-plastic-reconstructive-surgery',
    PHIR_PODIATRIC_SURGERY: 'phir-podiatric-surgery',
    PHIR_PREGNANCY_AND_BIRTH: 'phir-pregnancy-and-birth',
    PHIR_REHABILITATION: 'phir-rehabilitation',
    PHIR_SKIN: 'phir-skin',
    PHIR_SLEEP_STUDIES: 'phir-sleep-studies',
    PHIR_TONSILS_ADENOIDS_GROMMETS: 'phir-tonsils-adenoids-grommets',
    PHIR_WEIGHT_LOSS_SURGERY: 'phir-weight-loss-surgery',
};
const SERVICE_ITEM_GROUP = {
    CANCER_COUNCIL: 'cancer-council',
    DISEASE_MANAGEMENT: 'disease-management',
    EXERCISE_CLASSES: 'exercise-classes',
    HEALTH_CHECKS: 'health-checks',
    PREVENTATIVE_TESTS: 'preventative-tests',
    QUIT_SMOKING: 'quit-smoking',
    STRESS_MANAGEMENT: 'stress-management',
    SWIMMING_LESSONS: 'swimming-lessons',
};
const ROUTINE_DENTAL_SERVICE_ITEMS = {
    ADHESIVE_FILLING_BACK_1_SURFACE: 'routine-dental-adhesive-filling-back-1-surface',
    ADHESIVE_FILLING_BACK_3_SURFACES: 'routine-dental-adhesive-filling-back-3-surfaces',
    ADHESIVE_FILLING_FRONT_RESTORATION_1_SURFACE: 'routine-dental-adhesive-filling-front-1-surface',
    ADHESIVE_FILLING_FRONT_RESTORATION_3_SURFACES: 'routine-dental-adhesive-filling-front-3-surfaces',
    CLEAN_AND_POLISH: 'routine-dental-clean-and-polish',
    COMPREHENSIVE_EXAMINATION: 'routine-dental-comprehensive-examination',
    METALLIC_RESTORATION_1_SURFACE: 'routine-dental-metallic-restoration-1-surface',
    METALLIC_RESTORATION_3_SURFACES: 'routine-dental-metallic-restoration-3-surfaces',
    MOUTH_GUARD: 'routine-dental-mouth-guard',
    NON_SURGICAL_EXTRACTION: 'routine-dental-non-surgical-extraction',
    PERIODIC_EXAMINATION: 'routine-dental-periodic-examination',
    SCALE_AND_CLEAN: 'routine-dental-scale-and-clean',
    SURGICAL_EXTRACTION: 'routine-dental-surgical-extraction',
    TOPICAL_FLUORIDE_APPLICATION: 'routine-dental-topical-fluoride-application',
    XRAY_ONE_FILM: 'routine-dental-xray-one-film',
};
const SERVICE_ITEM = {
    [SERVICE.ACUPUNCTURE]: {
        ACUPUNCTURE_CONSULTATION: 'acupuncture-consultation',
    },
    [SERVICE.AUDIOLOGY]: {
        INITIAL_CONSULTATION: 'audiology-initial-consultation',
        SUBSEQUENT_CONSULTATION: 'audiology-subsequent-consultation',
    },
    [SERVICE.CHINESE_MEDICINE]: {
        CHINESE_MEDICINE_CONSULTATION: 'chinese-medicine-consultation',
    },
    [SERVICE.CHIROPRACTIC]: {
        CHIROPRACTIC_X_RAY: 'chiropractic-chiropractic-x-ray',
        INITIAL_CONSULTATION: 'chiropractic-initial-consultation',
        SUBSEQUENT_CONSULTATION: 'chiropractic-subsequent-consultation',
    },
    [SERVICE.COMPLEX_DENTAL]: {
        FILLING_OF_ONE_ROOT_CANAL: 'complex-dental-filling-of-one-root-canal',
        PREPARATION_OF_ONE_ROOT_CANAL: 'complex-dental-preparation-of-one-root-canal',
    },
    [SERVICE.COUNSELLING]: {
        INDIVIDUAL_CONSULTATION: 'counselling-individual-consultation',
        COUPLE_OR_FAMILY_CONSULTATION: 'counselling-couple-or-family-consultation',
        GROUP_CONSULTATION: 'counselling-group-consultation',
        INDIVIDUAL_TELEHEALTH_CONSULTATION: 'counselling-individual-telehealth-consultation',
        COUPLE_OR_FAMILY_TELEHEALTH_CONSULTATION: 'counselling-couple-or-family-telehealth-consultation',
    },
    [SERVICE.DIETETICS]: {
        INITIAL_CONSULTATION: 'dietetics-initial-consultation',
        INITIAL_CONSULTATION_TELECONSULTATION: 'dietetics-initial-consultation-teleconsultation',
        SUBSEQUENT_CONSULTATION: 'dietetics-subsequent-consultation',
        SUBSEQUENT_CONSULTATION_TELECONSULTATION: 'dietetics-subsequent-consultation-teleconsultation',
    },
    [SERVICE.EXERCISE_PHYSIOLOGY]: {
        EXERCISE_PHYSIOLOGY_CONSULTATION: 'exercise-physiology-consultation',
        EXERCISE_PHYSIOLOGY_CONSULTATION_TELECONSULTATION: 'exercise-physiology-consultation-teleconsultation',
    },
    [SERVICE.NUTRITION]: {
        INITIAL_CONSULTATION: 'nutrition-initial-consultation',
        INITIAL_CONSULTATION_TELECONSULTATION: 'nutrition-initial-consultation-teleconsultation',
        SUBSEQUENT_CONSULTATION: 'nutrition-subsequent-consultation',
        SUBSEQUENT_CONSULTATION_TELECONSULTATION: 'nutrition-subsequent-consultation-teleconsultation',
    },
    [SERVICE.WEIGHT_LOSS]: {
        PER_CLASS: 'weight-loss-per-class',
        PER_COURSE: 'weight-loss-per-course',
    },
    [SERVICE.HEALTH_IMPROVEMENT]: {
        CANCER_COUNCIL_PER_ITEM: 'health-improvement-cancer-council-per-item',
        DISEASE_MANAGEMENT_ASSOCIATION_ARTHRITIS: 'health-improvement-disease-management-association-arthritis',
        DISEASE_MANAGEMENT_ASSOCIATION_ASTHMA: 'health-improvement-disease-management-association-asthma',
        DISEASE_MANAGEMENT_ASSOCIATION_BREASTFEEDING: 'health-improvement-disease-management-association-breastfeeding',
        DISEASE_MANAGEMENT_ASSOCIATION_COELIAC: 'health-improvement-disease-management-association-coeliac',
        DISEASE_MANAGEMENT_ASSOCIATION_CROHNS_COLITIS: 'health-improvement-disease-management-association-crohns-colitis',
        DISEASE_MANAGEMENT_ASSOCIATION_DIABETES: 'health-improvement-disease-management-association-diabetes',
        DISEASE_MANAGEMENT_ASSOCIATION_HEART: 'health-improvement-disease-management-association-heart',
        DISEASE_MANAGEMENT_ASSOCIATION_OSTOMY: 'health-improvement-disease-management-association-ostomy',
        EXERCISE_CLASSES_PER_CLASS: 'health-improvement-exercise-classes-per-class',
        EXERCISE_CLASSES_PER_COURSE: 'health-improvement-exercise-classes-per-course',
        EXERCISE_PHYSIOLOGY_CLASSES_PER_CLASS: 'health-improvement-exercise-physiology-classes-per-class',
        EXERCISE_PHYSIOLOGY_CLASSES_PER_COURSE: 'health-improvement-exercise-physiology-classes-per-course',
        GYM_CLASSES_PER_CLASS: 'health-improvement-gym-classes-per-class',
        GYM_CLASSES_PER_COURSE: 'health-improvement-gym-classes-per-course',
        HEALTH_CHECKS_DOCTOR: 'health-improvement-health-checks-doctor',
        HEALTH_CHECKS_HEART: 'health-improvement-health-checks-heart',
        PREVENTATIVE_TESTS_PER_TEST: 'health-improvement-preventative-tests-per-test',
        QUIT_SMOKING_PER_COURSE: 'health-improvement-quit-smoking-per-course',
        QUIT_SMOKING_PER_ITEM: 'health-improvement-quit-smoking-per-item',
        STRESS_MANAGEMENT_PER_COURSE: 'health-improvement-stress-managment-per-course',
        SWIMMING_LESSONS_PER_COURSE: 'health-improvement-swimming-lessons-per-course',
        SWIMMING_LESSONS_PER_LESSON: 'health-improvement-swimming-lessons-per-lesson',
        TAI_CHI_CLASSES_PER_CLASS: 'health-improvement-tai-chi-classes-per-class',
        TAI_CHI_CLASSES_PER_COURSE: 'health-improvement-tai-chi-classes-per-course',
    },
    [SERVICE.MAJOR_DENTAL]: {
        BRIDGE_PONTIC_INDIRECT: 'major-dental-bridge-pontic-indirect',
        FULL_CROWN_NON_METALLIC: 'major-dental-full-crown-non-metallic',
        FULL_CROWN_VENEERED: 'major-dental-full-crown-veneered',
        FULL_DENTURE_LOWER: 'major-dental-full-denture-lower',
        FULL_DENTURE_UPPER: 'major-dental-full-denture-upper',
    },
    [SERVICE.MYOTHERAPY]: {
        MYOTHERAPY_CONSULTATION: 'myotherapy-consultation',
    },
    [SERVICE.NATURAL_THERAPY]: {
        ALEXANDER_TECHNIQUE: 'natural-therapy-alexander-technique',
        AROMATHERAPY: 'natural-therapy-aromatherapy',
        BIOCHEMISTRY: 'natural-therapy-biochemistry',
        BOWEN_THERAPY: 'natural-therapy-bowen-therapy',
        FELDENKRAIS: 'natural-therapy-feldenkrais',
        HERBALISM: 'natural-therapy-herbalism',
        HOMEOPATHY: 'natural-therapy-homeopathy',
        KINESIOLOGY: 'natural-therapy-kinesiology',
        NATUROPATHY: 'natural-therapy-naturopathy',
        OSTEOPATHY: 'natural-therapy-osteopathy',
        REFLEXOLOGY: 'natural-therapy-reflexology',
        ROLFING: 'natural-therapy-rolfing',
        SHIATSU: 'natural-therapy-shiatsu',
    },
    [SERVICE.OCCUPATIONAL_THERAPY]: {
        INITIAL_CONSULTATION: 'occupational-therapy-initial-consultation',
        INITIAL_CONSULTATION_TELECONSULTATION: 'occupational-therapy-initial-consultation-teleconsultation',
        SUBSEQUENT_CONSULTATION: 'occupational-therapy-subsequent-consultation',
        SUBSEQUENT_CONSULTATION_TELECONSULTATION: 'occupational-therapy-subsequent-consultation-teleconsultation',
    },
    [SERVICE.OPTICAL]: {
        BIFOCAL: 'optical-bifocal',
        CONTACT_LENSES: 'optical-contact-lenses',
        FRAMES: 'optical-frames',
        LENS_COATING: 'optical-lens-coating',
        MULTIFOCAL: 'optical-multifocal',
        REPAIR: 'optical-repair',
        SINGLE_VISION: 'optical-single-vision',
    },
    [SERVICE.ORTHODONTICS]: {
        SERVICES_GP_OR_DENTIST: 'orthodontics-services-gp-or-dentist',
    },
    [SERVICE.ORTHOPTICS]: {
        ORTHOPTICS_CONSULTATION: 'orthoptics-consultation',
    },
    [SERVICE.ORTHOTICS]: {
        ORTHOPAEDIC_SHOES_REPAIRS: 'orthopaedic-shoes-repairs',
        ORTHOTICS_REPAIRS: 'orthotics-repairs',
    },
    [SERVICE.OSTEOPATHY]: {
        INITIAL_CONSULTATION: 'osteopathy-initial-consultation',
        SUBSEQUENT_CONSULTATION: 'osteopathy-subsequent-consultation',
    },
    [SERVICE.PHARMACY]: {
        GENERAL_ITEMS: 'pharmacy-general-items',
        CONTRACEPTIVES: 'pharmacy-contraceptives',
        COSMETICS: 'pharmacy-cosmetics',
        VACCINES: 'pharmacy-vaccines',
    },
    [SERVICE.PHYSIOTHERAPY]: {
        INITIAL_CONSULTATION: 'physiotherapy-initial-consultation',
        INITIAL_CONSULTATION_TELECONSULTATION: 'physiotherapy-initial-consultation-teleconsultation',
        SUBSEQUENT_CONSULTATION: 'physiotherapy-subsequent-consultation',
        SUBSEQUENT_CONSULTATION_TELECONSULTATION: 'physiotherapy-subsequent-consultation-teleconsultation',
        ONE_ON_ONE_HYDROTHERAPY: 'physiotherapy-one-on-one-hydrotherapy',
        GROUP_HYDROTHERAPY: 'physiotherapy-group-pilates',
        CLINICAL_PILATES: 'physiotherapy-pilates',
        PRE_ANTE_NATAL_PHYSIOTHERAPY: 'physiotherapy-pre-ante-natal-physiotherapy',
        GROUP_ANTE_NATAL_EXERCISE: 'physiotherapy-group-ante-natal-exercise',
        GROUP_REHABILITATION: 'physiotherapy-group-rehabilitation',
        OCCUPATIONAL_THERAPY_INITIAL_CONSULTATION: 'physiotherapy-occupational-therapy-initial-consultation',
        OCCUPATIONAL_THERAPY_SUBSEQUENT_CONSULTATION: 'physiotherapy-occupational-therapy-subsequent-consultation',
    },
    [SERVICE.PODIATRY]: {
        CASTING: 'podiatry-casting',
        INITIAL_CONSULTATION: 'podiatry-initial-consultation',
        INITIAL_CONSULTATION_TELECONSULTATION: 'podiatry-initial-consultation-teleconsultation',
        PODIATRIC_SURGERY: 'podiatry-podiatric-surgery',
        SUBSEQUENT_CONSULTATION: 'podiatry-subsequent-consultation',
        SUBSEQUENT_CONSULTATION_TELECONSULTATION: 'podiatry-subsequent-consultation-teleconsultation',
        BIOMECHANICAL_ASSESSMENT: 'biomechanical-assessment',
    },
    [SERVICE.PRE_POST_NATAL]: {
        BIRTHING_COURSES: 'pre-post-natal-birthing-courses',
        CONSULTATIONS_AND_CLASSES: 'pre-post-natal-consultations-and-classes',
        LACTATION_CONSULTANT: 'pre-post-natal-lactation-consultant',
        PREGNANCY_COMPRESSION_GARMENTS: 'pre-post-natal-pregnancy-compression-garments',
    },
    [SERVICE.PSYCHOLOGY]: {
        INITIAL_CONSULTATION: 'psychology-initial-consultation',
        INITIAL_CONSULTATION_TELECONSULTATION: 'psychology-initial-consultation-teleconsultation',
        SUBSEQUENT_CONSULTATION: 'psychology-subsequent-consultation',
        SUBSEQUENT_CONSULTATION_TELECONSULTATION: 'psychology-subsequent-consultation-teleconsultation',
        GROUP_CONSULTATION: 'psychology-group-consultation',
    },
    [SERVICE.PSYCHOLOGY_HYPNOTHERAPY]: {
        GROUP_CONSULTATION: 'psychology-hypnotherapy-group-consultation',
        INITIAL_CONSULTATION: 'psychology-hypnotherapy-initial-consultation',
        SUBSEQUENT_CONSULTATION: 'psychology-hypnotherapy-subsequent-consultation',
    },
    [SERVICE.REMEDIAL_MASSAGE]: {
        REMEDIAL_MASSAGE_CONSULTATION: 'remedial-massage-consultation',
    },
    [SERVICE.ROUTINE_DENTAL]: ROUTINE_DENTAL_SERVICE_ITEMS,
    [SERVICE.SPEECH_THERAPY]: {
        INITIAL_CONSULTATION: 'speech-therapy-initial-consultation',
        INITIAL_CONSULTATION_TELECONSULTATION: 'speech-therapy-initial-consultation-teleconsultation',
        SUBSEQUENT_CONSULTATION: 'speech-therapy-subsequent-consultation',
        SUBSEQUENT_CONSULTATION_TELECONSULTATION: 'speech-therapy-subsequent-consultation-teleconsultation',
    },
    [SERVICE.EYE_THERAPY]: {
        INITIAL_CONSULTATION: 'eye-therapy-initial-consultation',
        SUBSEQUENT_CONSULTATION: 'eye-therapy-subsequent-consultation',
    },
    [SERVICE.HEARING_AIDS]: {
        PER_HEARING_AID: 'hearing-aids-per-hearing-aid',
        REPAIR: 'hearing-aids-repair',
    },
    [SERVICE.JOINT_FLUID_INJECTIONS]: {
        PER_INJECTION: 'joint-fluid-injections-per-injection',
    },
    [SERVICE.MEDICAL_GASES]: {
        PER_UNIT: 'medical-gases-per-unit',
        OXYGEN_CONCENTRATOR: 'medical-gases-oxygen-concentrator',
    },
    [SERVICE.TRAVEL_ACCOMMODATION]: {
        TRAVEL_OVER_200KM: 'travel-accommodation-travel-over-200km',
        ACCOMMODATION_PER_NIGHT: 'travel-accommodation-accommodation-per-night',
    },
    [SERVICE.POST_OPERATIVE_MEDICAL_AIDS]: {
        POST_OPERATIVE_AID: 'post-operative-medical-aids-post-operative-aid',
        BRACES_AND_SUPPORTS: 'post-operative-medical-aids-braces-and-supports',
        MEDICAL_AIDS: 'post-operative-medical-aids-medical-aids',
        NON_SURGICAL_PROSTHESIS: 'post-operative-medical-aids-non-surgical-prosthesis',
        IRLEN_LENS: 'post-operative-medical-aids-irlen-lens',
    },
    [SERVICE.OUTPATIENT]: {
        PER_PROCEDURE_ROOM_FEE: 'outpatient-per-procedure-room-fee',
    },
    [SERVICE.LASER_EYE_SURGERY]: {
        REFRACTIVE_LASER_EYE_SURGERY: 'laser-eye-surgery-refractive-laser-eye-surgery',
    },
    [SERVICE.HYPNOTHERAPY]: {
        INITIAL_CONSULTATION: 'hypnotherapy-initial-consultation',
        SUBSEQUENT_CONSULTATION: 'hypnotherapy-subsequent-consultation',
    },
    [SERVICE.BASIC_DENTAL]: ROUTINE_DENTAL_SERVICE_ITEMS,
    [SERVICE.GENERAL_DENTAL]: ROUTINE_DENTAL_SERVICE_ITEMS,
};
const PAYMENT_METHOD = {
    BRANCH: 'branch',
    DIRECT_DEBIT: 'direct-debit',
    GROUP: 'group',
};
const DIRECT_DEBIT_TYPE = {
    BANK: 'bank',
    CREDIT_CARD: 'credit',
};
const TITLE = {
    MR: 'mr',
    MRS: 'mrs',
    MX: 'mx',
    MISS: 'miss',
    MS: 'ms',
    DR: 'dr',
};
const GENDER = {
    MALE: 'male',
    FEMALE: 'female',
};
const RELATIONSHIP = {
    CLIENT: 'client',
    SPOUSE: 'spouse',
    CHILD: 'child',
    STUDENT_DEPENDANT: 'student-dependant',
    ADULT_DEPENDANT: 'adult-dependant',
};
const PROMO_CODE = {
    JANUARY_OFFER: 'januaryoffer',
    FEBRUARY_OFFER: 'februaryoffer',
    MARCH_OFFER: 'marchoffer',
    APRIL_OFFER: 'apriloffer',
    MAY_OFFER: 'mayoffer',
    JUNE_OFFER: 'juneoffer',
    JULY_OFFER: 'julyoffer',
    AUGUST_OFFER: 'augustoffer',
    SEPTEMBER_OFFER: 'septemberoffer',
    OCTOBER_OFFER: 'octoberoffer',
    NOVEMBER_OFFER: 'novemberoffer',
    DECEMBER_OFFER: 'decemberoffer',
    FLYBUYS_SIX_WEEKS_FREE: 'flybuys6wks',
    FLYBUYS: 'ahmflybuys',
    GIFTCARD: 'giftcard',
    HOYTSWW: 'hoytsww',
    JETSTAR_FREEBIE_6: 'jetstarfreebie6',
    JETSTAR_FREEBIE: 'jetstarfreebie4',
    KOGAN_GIFTCARD: 'kogangc',
    KOGAN_ONE_MONTH_FREE_WAIVED_WAITS: 'koganmonth',
    KOGAN_ONE_MONTH_FREE: 'koganmonth',
    KOGAN_SIX_WEEKS_FREE_WAIVED_WAITS: 'freekogan',
    KOGAN_TWO_HUNDRED_DOLLARS_OFF: 'freekogan',
    KOGAN_WAIVE: 'koganwaive',
    ONE_MONTH_FREE_WAIVED_WAITS: '1mfreeww',
    ONE_MONTH_FREE_NO_WAIVED_WAITS: 'monthfree',
    SIX_WEEKS_FREE_WAIVED_WAITS: '6wfreeww',
    SUNGLASS_HUT: 'getsun',
    TELSTRA_FREEBIE_6: 'telstrafreebie6',
    TELSTRA_FREEBIE: 'telstrafreebie',
    TWO_HUNDRED_DOLLARS_OFF: '$offahm',
    UP_TO_ONE_HUNDRED_OFF: '$offahm',
    WAIVE_WAITS: 'waivewaits',
};
const CHANGE_COVER_CAMPAIGN_CODE = {
    FOUR_WEEKS_FREE: 'four-weeks-free',
};
const CHANGE_COVER_PROMO_CODE = {
    [CHANGE_COVER_CAMPAIGN_CODE.FOUR_WEEKS_FREE]: '4WKSFREECC',
};
const ENROL_CODE = {
    NEW: 'new',
    TRANSFERRING: 'transferring',
};
const ENROL_TYPE_BY_CODE = {
    '1': ENROL_CODE.NEW,
    '3': ENROL_CODE.TRANSFERRING,
};
const CREDIT_CARD_TYPE = {
    MASTERCARD: 'mastercard',
    VISA: 'visa',
};
const HEALTH_FUND = {
    AAMI: 'aami',
    ACA: 'aca',
    APIA: 'apia',
    AUSTRALIAN_COUNTRY_HEALTH: 'australian-country-health',
    AUSTRALIAN_UNITY: 'australian-unity',
    BUDGET_DIRECT: 'budget-direct',
    BUPA: 'bupa',
    CBHS: 'cbhs',
    CDH: 'cdh',
    CENTRAL_WEST: 'central-west',
    COUNTRY_HEALTH: 'country-health',
    CREDICARE: 'credicare',
    CUA: 'cua',
    CY_HEALTH: 'cy-health',
    DEFENCE: 'defence',
    DOCTORS: 'doctors',
    DRUIDS: 'Druids',
    FEDERATION_HEALTH: 'federation-health',
    FIT: 'fit',
    FRANK: 'frank',
    GMF: 'gmf',
    GMHBA: 'gmhba',
    GOLDFIELDS: 'goldfields',
    GRAND_UNITED: 'grand-united',
    GU: 'gu',
    HBA: 'hba',
    HBF: 'hbf',
    HCF: 'hcf',
    HEALTH_CARE_INSURANCE: 'health-care-insurance',
    HEALTH_COM_AU: 'health-com-au',
    HEALTH_PARTNERS: 'health-partners',
    HEALTHGUARD: 'healthguard',
    HIF: 'hif',
    ILLAWARRA_HEALTH_FUND: 'illawarra-health-fund',
    IMAN: 'iman',
    IOOF: 'ioof',
    IOR: 'ior',
    LATROBE: 'latrobe',
    MANCHESTER_UNITY: 'manchester-unity',
    MBF: 'mbf',
    MDHF: 'mdhf',
    MEDIBANK: 'medibank',
    MUTUAL_COMMUNITY: 'mutual-community',
    MUTUAL_HEALTH: 'mutual-health',
    MY_OWN: 'my-own',
    NAVY: 'navy',
    NIB: 'nib',
    NRMA_HEALTH: 'nrma-health',
    NSW_TEACHERS_FEDERATION: 'nsw-teachers-federation',
    NURSES_AND_MIDWIVES_HEALTH: 'nurses-and-midwives-health',
    ONEMEDIFUND: 'onemedifund',
    OTHER: 'other',
    PEOPLECARE: 'peoplecare',
    PHOENIX: 'phoenix',
    POLICE: 'police',
    QANTAS_ASSURE: 'qantas-assure',
    QUEENSLAND_COUNTRY: 'queensland-country',
    QUEENSLAND_TEACHERS_UNION: 'queensland-teachers-union',
    RACT: 'ract',
    RBHS: 'rbhs',
    RT: 'rt',
    SGIC_SA: 'sgic-sa',
    SGIC_WA: 'sgic-wa',
    ST_LUKES: 'st-lukes',
    SUNCORP: 'suncorp',
    TEACHERS_HEALTH: 'teachers-health',
    TRANSPORT: 'transport',
    UNIHEALTH: 'unihealth',
    WESTFUND: 'westfund',
};
const PMOC_CATEGORY = {
    MEMBERSHIP: 'membership',
    MARKETING: 'marketing',
    SMS_MARKETING: 'sms-marketing',
};
// PMOC values for membership category
const PMOC_CHANNEL = {
    EMAIL: 'email',
    POST: 'post',
    NOT_NOMINATED: 'not-nominated',
};
// PMOC values are different for marketing category
const PMOC_CHANNEL_MARKETING = {
    EMAIL: 'email',
    POST: 'post',
    DO_NOT_MARKET: 'do-not-market',
    NO_RESTRICTIONS: 'no-restrictions',
};
const PMOC_CHANNEL_SMS = {
    YES: true,
    NO: false,
};
const SMS_CONTACT_CATEGORY = {
    MARKETING: 'marketing',
    POLICY: 'policy',
};
const SMS_CONTACT_CATEGORY_TYPE = {
    [SMS_CONTACT_CATEGORY.MARKETING]: 'M',
    [SMS_CONTACT_CATEGORY.POLICY]: 'P',
};
const USER_TYPE = {
    PRIMARY: 'primary',
    MEMBER: 'member',
};
const RESET_INDICATOR = {
    START: 'start',
    FINISH: 'finish',
};
const MEMBER_STATUS = {
    ACTIVE: 'A',
    PENDING: 'P',
    TERMINATED: 'T',
    WAITING_FOR_RENEWAL: 'W',
};
const NOTIFY_METHOD = {
    EMAIL: 'email',
    SMS: 'sms',
};
const HEALTH_POLICY_STATUS = {
    ACTIVE: 'active',
    SUSPENDED: 'suspended',
    TERMINATED: 'terminated',
    INCOMPLETE: 'incomplete',
    PROSPECT: 'prospect',
};
const LIVE_CHAT_STATUS = {
    UNKNOWN: 0,
    ONLINE: 1,
    OFFLINE: 2,
    CONTENT: 3, // We don’t know what this means either.
    BUSY: 4,
};
const HOSPITAL_PRODUCT_TIER = {
    BASIC: 'basic',
    BASIC_PLUS: 'basic plus',
    BRONZE: 'bronze',
    BRONZE_PLUS: 'bronze plus',
    SILVER: 'silver',
    SILVER_PLUS: 'silver plus',
    GOLD: 'gold',
};
const REFORM_CHANGE_LEVELS = {
    MODIFY: 'MODIFY',
    DETRIMENTAL_LITE: 'DETRIMENTAL_LITE',
    RETIRE: 'RETIRE',
};
const PRODUCT_LIMIT_CATEGORY = {
    AUDIOLOGY: 'audiology',
    BASIC_DENTAL: 'basic-dental',
    CHIROPRACTIC: 'chiropractic',
    COMBINED_ANCILLARY: 'combined-ancillary',
    COMBINED_DENTAL: 'combined-dental',
    COMBINED_THERAPIES: 'combined-therapies',
    COMPLEMENTARY_THERAPIES: 'complementary-therapies',
    COMPLEX_DENTAL: 'complex-dental',
    COMPLEX_MAJOR_DENTAL: 'complex-major-dental',
    COUNSELLING: 'counselling',
    DIETETICS_NUTRITION_WEIGHT_LOSS: 'dietetics-nutrition-weight-loss',
    EYE_THERAPY: 'eye-therapy',
    GENERAL_DENTAL: 'general-dental',
    HEALTH_IMPROVEMENT: 'health-improvement',
    HEARING_AIDS: 'hearing-aids',
    HIGH_COST_DENTAL: 'high-cost-dental',
    HYPNOTHERAPY: 'hypnotherapy',
    JOINT_FLUID_INJECTIONS: 'joint-fluid-injections',
    LASER_EYE_SURGERY: 'laser-eye-surgery',
    MAJOR_DENTAL: 'major-dental',
    MEDICAL_GASES: 'medical-gases',
    MUSCLE_BONE: 'muscle-bone',
    NATURAL_THERAPY: 'natural-therapy',
    OCCUPATIONAL_THERAPY: 'occupational-therapy',
    OPTICAL: 'optical',
    ORTHODONTICS_LIFETIME: 'orthodontics-lifetime',
    ORTHODONTICS: 'orthodontics',
    ORTHOTICS: 'orthotics',
    OSTEOPATHY: 'osteopathy',
    OUTPATIENT: 'outpatient',
    PHARMACY: 'pharmacy',
    PHYSIO_CHIRO_OSTEO: 'physio-chiro-osteo',
    PHYSIOTHERAPY_OCCUPATIONAL_THERAPY: 'physiotherapy-occupational-therapy',
    PHYSIOTHERAPY: 'physiotherapy',
    PODIATRY: 'podiatry',
    POST_OPERATIVE_MEDICAL_AIDS: 'post-operative-medical-aids',
    PRE_POST_NATAL: 'pre-post-natal',
    PSYCH_HYPNO_PODIATRY_ORTHOTICS: 'psych-hypno-podiatry-orthotics',
    PSYCHOLOGY_HYPNOTHERAPY: 'psychology-hypnotherapy',
    PSYCHOLOGY: 'psychology',
    REMEDIAL_MASSAGE: 'remedial-massage',
    ROUTINE_DENTAL: 'routine-dental',
    SINGLE_LIMIT_COMBINED: 'single-limit-combined',
    SPEECH_THERAPY: 'speech-therapy',
    TEETH: 'teeth',
    TRAVEL_ACCOMMODATION: 'travel-accommodation',
    WELLBEING: 'wellbeing',
};
const PROVIDER_OCCUPATIONS = {
    [SERVICE.ACUPUNCTURE]: 'acupuncturist',
    [SERVICE.CHINESE_MEDICINE]: 'Chinese medicine practitioner',
    [SERVICE.EXERCISE_PHYSIOLOGY]: 'exercise physiologist',
    [SERVICE.MYOTHERAPY]: 'myotherapist',
    [SERVICE_ITEM_GROUP.STRESS_MANAGEMENT]: 'psychologist',
    [SERVICE_ITEM_GROUP.SWIMMING_LESSONS]: 'swim school',
    [SERVICE.AUDIOLOGY]: 'audiologist',
    [SERVICE.CHIROPRACTIC]: 'chiropractor',
    [SERVICE.COUNSELLING]: 'counsellor',
    [SERVICE.DIETETICS]: 'dietitian',
    [SERVICE.EYE_THERAPY]: 'orthoptist',
    [SERVICE.HYPNOTHERAPY]: 'hypnotherapist',
    [SERVICE.LASER_EYE_SURGERY]: 'laser eye surgeon',
    [SERVICE.NUTRITION]: 'nutritionist',
    [SERVICE.OCCUPATIONAL_THERAPY]: 'occupational therapist',
    [SERVICE.ORTHODONTICS]: 'orthodontist',
    [SERVICE.ORTHOTICS]: 'orthotics supplier',
    [SERVICE.OSTEOPATHY]: 'osteopath',
    [SERVICE.PHYSIOTHERAPY]: 'physiotherapist',
    [SERVICE.PODIATRY]: 'podiatrist',
    [SERVICE.PRE_POST_NATAL]: 'registered midwife',
    [SERVICE.PSYCHOLOGY]: 'psychologist',
    [SERVICE.REMEDIAL_MASSAGE]: 'remedial massage therapist',
    [SERVICE.SPEECH_THERAPY]: 'speech therapist',
};
const DATE_FORMAT = {
    HUMAN: 'D MMMM YYYY',
    ISO_8601: 'YYYY-MM-DD',
    ISO_8601_WITH_TIME: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    ISO_8601_WITH_TIME_WITHOUT_OFFSET: 'YYYY-MM-DDTHH:mm:ss.SSS',
    STANDARD: 'DD/MM/YYYY',
};
const DENTAL_SERVICE_IDS = [
    SERVICE.COMPLEX_DENTAL,
    SERVICE.MAJOR_DENTAL,
    SERVICE.ROUTINE_DENTAL,
    SERVICE.ORTHODONTICS,
];
const PROVIDER_TYPE = {
    ANCILLARY: 'ancillary',
    DENTAL: 'dental',
    HOSPITAL: 'hospital',
    MEDICAL: 'medical',
};
const AUTHORISED_PERSON_RELATIONSHIP = {
    CHILD: 'child',
    OTHER: 'other',
    PARENT: 'parent',
    PARTNER: 'partner',
    POWER_OF_ATTORNEY: 'power-of-attorney',
    SIBLING: 'sibling',
    SPOUSE: 'spouse',
};
const CONDITION_CODE = {
    ARTHRITIS: 'AR',
    ASTHMA: 'AS',
    CARDIAC_HEART: 'CD',
    DIABETES: 'DB',
    OTHER: 'OT',
    RESTRICTED_PHARMACY: 'PH',
    SLEEP_APNOEA: 'SA',
    UNHEALTHY_BMI: 'UB',
};
const CONDITION_CODE_DESCRIPTION = {
    [CONDITION_CODE.ARTHRITIS]: 'Arthritis',
    [CONDITION_CODE.ASTHMA]: 'Asthma',
    [CONDITION_CODE.CARDIAC_HEART]: 'Cardiac Heart',
    [CONDITION_CODE.DIABETES]: 'Diabetes',
    [CONDITION_CODE.OTHER]: 'Other',
    [CONDITION_CODE.RESTRICTED_PHARMACY]: 'Restricted Pharmacy',
    [CONDITION_CODE.SLEEP_APNOEA]: 'Sleep Apnoea',
    [CONDITION_CODE.UNHEALTHY_BMI]: 'Unhealthy BMI',
};
/*
 * EXERCISE_CLASS and EXERCISE_COURSE are mapped to the same item codes as GYM_CLASS and GYM_COURSE due to how they are
 * mapped in the API and front-end these are different to EXERCISE_PHYSIOLOGY_CLASS and EXERCISE_PHYSIOLOGY_COURSE
 */
const CONDITION_CODE_ITEMS = {
    COSMETICS: {
        service: SERVICE_ITEM[SERVICE.PHARMACY].COSMETICS,
        name: 'Cosmetics',
        code: '9012M',
    },
    CONTRACEPTIVES: {
        service: SERVICE_ITEM[SERVICE.PHARMACY].CONTRACEPTIVES,
        name: 'Contraceptive',
        code: '9012C',
    },
    EXERCISE_CLASS: {
        service: SERVICE_ITEM[SERVICE.HEALTH_IMPROVEMENT].EXERCISE_CLASSES_PER_CLASS,
        name: 'Exercise Class',
        code: '8005',
    },
    EXERCISE_COURSE: {
        service: SERVICE_ITEM[SERVICE.HEALTH_IMPROVEMENT].EXERCISE_CLASSES_PER_COURSE,
        name: 'Exercise Course',
        code: '8105',
    },
    EXERCISE_PHYSIOLOGY_CLASS: {
        service: SERVICE_ITEM[SERVICE.HEALTH_IMPROVEMENT].EXERCISE_PHYSIOLOGY_CLASSES_PER_CLASS,
        name: 'Exercise Physiology Class',
        code: '8020',
    },
    EXERCISE_PHYSIOLOGY_COURSE: {
        service: SERVICE_ITEM[SERVICE.HEALTH_IMPROVEMENT].EXERCISE_PHYSIOLOGY_CLASSES_PER_COURSE,
        name: 'Exercise Physiology Course',
        code: '8120',
    },
    GYM_CLASS: {
        service: SERVICE_ITEM[SERVICE.HEALTH_IMPROVEMENT].GYM_CLASSES_PER_CLASS,
        name: 'Gym Class',
        code: '8005',
    },
    GYM_COURSE: {
        service: SERVICE_ITEM[SERVICE.HEALTH_IMPROVEMENT].GYM_CLASSES_PER_COURSE,
        name: 'Gym Course',
        code: '8105',
    },
    JOINT_FLUID_REPLACEMENT_THERAPY: {
        service: SERVICE.JOINT_FLUID_INJECTIONS,
        name: 'Joint Fluid Replacement Therapy',
        code: '9110',
    },
    SWIMMING_LESSONS_CLASS: {
        service: SERVICE_ITEM[SERVICE.HEALTH_IMPROVEMENT].SWIMMING_LESSONS_PER_LESSON,
        name: 'Swimming Lessons Class',
        code: '8003',
    },
    SWIMMING_LESSONS_COURSE: {
        service: SERVICE_ITEM[SERVICE.HEALTH_IMPROVEMENT].SWIMMING_LESSONS_PER_COURSE,
        name: 'Swimming Lessons Course',
        code: '8103',
    },
    WEIGHT_LOSS_CLASSES: {
        service: SERVICE_ITEM[SERVICE.WEIGHT_LOSS].PER_CLASS,
        name: 'Weight Loss Classes',
        code: '9196',
    },
    WEIGHT_LOSS_COURSE: {
        service: SERVICE_ITEM[SERVICE.WEIGHT_LOSS].PER_COURSE,
        name: 'Weight Loss Course',
        code: '9096',
    },
};
const CONDITIONS = {
    [CONDITION_CODE.RESTRICTED_PHARMACY]: [CONDITION_CODE_ITEMS.CONTRACEPTIVES],
    [CONDITION_CODE.ARTHRITIS]: [
        CONDITION_CODE_ITEMS.EXERCISE_CLASS,
        CONDITION_CODE_ITEMS.EXERCISE_COURSE,
        CONDITION_CODE_ITEMS.EXERCISE_PHYSIOLOGY_CLASS,
        CONDITION_CODE_ITEMS.EXERCISE_PHYSIOLOGY_COURSE,
        CONDITION_CODE_ITEMS.GYM_CLASS,
        CONDITION_CODE_ITEMS.GYM_COURSE,
    ],
    [CONDITION_CODE.ASTHMA]: [CONDITION_CODE_ITEMS.SWIMMING_LESSONS_CLASS, CONDITION_CODE_ITEMS.SWIMMING_LESSONS_COURSE],
    [CONDITION_CODE.CARDIAC_HEART]: [
        CONDITION_CODE_ITEMS.EXERCISE_CLASS,
        CONDITION_CODE_ITEMS.EXERCISE_COURSE,
        CONDITION_CODE_ITEMS.EXERCISE_PHYSIOLOGY_CLASS,
        CONDITION_CODE_ITEMS.EXERCISE_PHYSIOLOGY_COURSE,
        CONDITION_CODE_ITEMS.GYM_CLASS,
        CONDITION_CODE_ITEMS.GYM_COURSE,
        CONDITION_CODE_ITEMS.WEIGHT_LOSS_CLASSES,
        CONDITION_CODE_ITEMS.WEIGHT_LOSS_COURSE,
    ],
    [CONDITION_CODE.DIABETES]: [
        CONDITION_CODE_ITEMS.EXERCISE_CLASS,
        CONDITION_CODE_ITEMS.EXERCISE_COURSE,
        CONDITION_CODE_ITEMS.EXERCISE_PHYSIOLOGY_CLASS,
        CONDITION_CODE_ITEMS.EXERCISE_PHYSIOLOGY_COURSE,
        CONDITION_CODE_ITEMS.GYM_CLASS,
        CONDITION_CODE_ITEMS.GYM_COURSE,
        CONDITION_CODE_ITEMS.SWIMMING_LESSONS_CLASS,
        CONDITION_CODE_ITEMS.SWIMMING_LESSONS_COURSE,
        CONDITION_CODE_ITEMS.WEIGHT_LOSS_CLASSES,
        CONDITION_CODE_ITEMS.WEIGHT_LOSS_COURSE,
    ],
    [CONDITION_CODE.OTHER]: [
        CONDITION_CODE_ITEMS.EXERCISE_CLASS,
        CONDITION_CODE_ITEMS.EXERCISE_COURSE,
        CONDITION_CODE_ITEMS.EXERCISE_PHYSIOLOGY_CLASS,
        CONDITION_CODE_ITEMS.EXERCISE_PHYSIOLOGY_COURSE,
        CONDITION_CODE_ITEMS.GYM_CLASS,
        CONDITION_CODE_ITEMS.GYM_COURSE,
        CONDITION_CODE_ITEMS.JOINT_FLUID_REPLACEMENT_THERAPY,
        CONDITION_CODE_ITEMS.SWIMMING_LESSONS_CLASS,
        CONDITION_CODE_ITEMS.SWIMMING_LESSONS_COURSE,
        CONDITION_CODE_ITEMS.WEIGHT_LOSS_CLASSES,
        CONDITION_CODE_ITEMS.WEIGHT_LOSS_COURSE,
    ],
    [CONDITION_CODE.SLEEP_APNOEA]: [
        CONDITION_CODE_ITEMS.EXERCISE_CLASS,
        CONDITION_CODE_ITEMS.EXERCISE_COURSE,
        CONDITION_CODE_ITEMS.GYM_CLASS,
        CONDITION_CODE_ITEMS.GYM_COURSE,
        CONDITION_CODE_ITEMS.WEIGHT_LOSS_CLASSES,
        CONDITION_CODE_ITEMS.WEIGHT_LOSS_COURSE,
    ],
    [CONDITION_CODE.UNHEALTHY_BMI]: [
        CONDITION_CODE_ITEMS.EXERCISE_CLASS,
        CONDITION_CODE_ITEMS.EXERCISE_COURSE,
        CONDITION_CODE_ITEMS.EXERCISE_PHYSIOLOGY_CLASS,
        CONDITION_CODE_ITEMS.EXERCISE_PHYSIOLOGY_COURSE,
        CONDITION_CODE_ITEMS.GYM_CLASS,
        CONDITION_CODE_ITEMS.GYM_COURSE,
        CONDITION_CODE_ITEMS.SWIMMING_LESSONS_CLASS,
        CONDITION_CODE_ITEMS.SWIMMING_LESSONS_COURSE,
        CONDITION_CODE_ITEMS.WEIGHT_LOSS_CLASSES,
        CONDITION_CODE_ITEMS.WEIGHT_LOSS_COURSE,
    ],
};
const HIF_STATUS = {
    INVALID_DATE: 'INVALID_DATE',
    REQUIRED: 'REQUIRED',
    VALID: 'VALID',
};
const HIF_SUPPORTING_DOCUMENT_TYPE = {
    HEALTH_IMPROVEMENT_BENEFIT_FORM: 'Heath Improvement Benefit approval form',
    REFERRAL_LETTER_APPROVAL_FORM: 'Referral Letter approval form',
};
const SUSPENDED_CLAIM_STATUS = {
    HIF_REQUIRED: 'hif-required',
    RECEIPT_REQUIRED: 'receipt-required',
    DEFAULT: 'default',
    ITEM_NOT_PAYABLE_WITH_SELECTED_COMBINATION: 'item-not-payable-with-selected-combination',
};
const CONSENT_STATUS = {
    IN: 'in',
    NOT_APPLICABLE: 'not-applicable',
    OUT: 'out',
    PENDING: 'pending',
};
const EXPRESS_CONSENT_STATUS = {
    IN: 'I',
    OUT: 'O',
    NOT_APPLICABLE: 'N',
    PENDING: 'P',
};
const GENERIC_PROVIDER = {
    PHARMACY: 'PHARMACY',
    WELLNESS: 'WELLNESS',
    HEARAID: 'HEARAID',
    TRAVACC: 'TRAV/ACC',
    EQUIP: 'EQUIP',
    PROCROOM: 'PROCROOM',
};
const GENERIC_PROVIDER_FOR_SERVICE_OR_SERVICE_ITEM_GROUP = {
    [GENERIC_PROVIDER.PHARMACY]: [SERVICE.PHARMACY],
    [GENERIC_PROVIDER.WELLNESS]: [
        SERVICE_ITEM_GROUP.CANCER_COUNCIL,
        SERVICE_ITEM_GROUP.DISEASE_MANAGEMENT,
        SERVICE_ITEM_GROUP.EXERCISE_CLASSES,
        SERVICE_ITEM_GROUP.PREVENTATIVE_TESTS,
        SERVICE_ITEM_GROUP.QUIT_SMOKING,
        SERVICE.WEIGHT_LOSS,
        SERVICE_ITEM_GROUP.HEALTH_CHECKS,
    ],
    [GENERIC_PROVIDER.HEARAID]: [SERVICE.HEARING_AIDS],
    [GENERIC_PROVIDER.TRAVACC]: [SERVICE.TRAVEL_ACCOMMODATION],
    [GENERIC_PROVIDER.EQUIP]: [
        SERVICE.MEDICAL_GASES,
        SERVICE.JOINT_FLUID_INJECTIONS,
        SERVICE.POST_OPERATIVE_MEDICAL_AIDS,
    ],
    [GENERIC_PROVIDER.PROCROOM]: [SERVICE.OUTPATIENT],
};
const LIFE_INSURANCE = {
    AHM_LIFE_INSURANCE: 'ahm life insurance',
    AHM_LIFE_INSURANCE_EXPRESS: 'ahm life insurance express',
};
const WEB_VIEW_COOKIE = {
    WEB_VIEW_ACCESS_TOKEN: 'webViewAccessToken',
    VIEW_MODE: 'viewMode',
};
const VIEW_MODE = {
    WEB_VIEW: 'webView',
};
const REDIRECT_TYPE = {
    PERMANENT: 301,
    TEMPORARY: 302,
};
// A reasonability error is returned from WHICS and used indicate the status of a benefit back claim.
// These are used to generate the appropriate error message to display to the member
const BENEFIT_BACK_REASONABILITY_TYPE = {
    CONFLICTING_CLAIM_ITEMS: 'conflicting-claim-items',
    MISSING_SUPPORTING_CLAIM_ITEMS: 'missing-supporting-claim-items',
};
// LIFETIME_LIMIT is determined by WHICS if the LValueDateLimitTo is 30/12/9999
const BENEFIT_BACK_LIMIT_DATES = {
    LIFETIME_LIMIT: '30/12/9999',
};
const BENEFIT_BACK_STATUS = {
    ITEM_NUMBER_INVALID: 'item-number-invalid',
    SERVICE_NOT_AVAILABLE_ON_POLICY: 'service-not-available-on-policy',
    NOT_APPLICABLE_MEMBER_GENDER: 'not-applicable-member-gender',
    NOT_APPLICABLE_MEMBER_AGE: 'not-applicable-member-age',
    WAITING_PERIOD_ACTIVE: 'waiting-period-active',
    NO_COVER_FOUND: 'no-cover-found',
    MEMBERSHIP_NOT_FOUND: 'membership-not-found',
    MEMBERSHIP_IS_SUSPENDED: 'membership-is-suspended',
    MEMBERSHIP_IS_TERMINATED: 'membership-is-terminated',
    MEMBERSHIP_HAS_FUTURE_DATE_JOINED_FUND: 'membership-has-future-date-joined-fund',
    CUSTOMER_NOT_FOUND: 'customer-not-found',
    CUSTOMER_NOT_YET_ACTIVE: 'customer-not-yet-active',
    CUSTOMER_CEASED_PRIOR_TO_EFFECTIVE_DATE: 'customer-ceased-prior-to-effective-date',
    OMS_SERVICE_TYPE_NOT_VALID: 'oms-service-type-not-valid',
    BENEFITS_SET_AT_ZERO: 'benefits-set-at-zero',
    CHARGE_IS_LESS_THAN_OR_EQUAL_PBS: 'charge-is-less-than-or-equal-pbs',
    SERVICE_LIMIT_REACHED_INDIVIDUAL_DUE_TO_ENQUIRY: 'service-limit-reached-individual-due-to-enquiry',
    SERVICE_LIMIT_REACHED_INDIVIDUAL_DUE_TO_CLAIMING: 'service-limit-reached-individual-due-to-claiming',
    SERVICE_LIMIT_REDUCED_INDIVIDUAL_DUE_TO_ENQUIRY: 'service-limit-reduced-individual-due-to-enquiry',
    SERVICE_LIMIT_REDUCED_INDIVIDUAL_DUE_TO_CLAIMING: 'service-limit-reduced-individual-due-to-claiming',
    BENEFIT_LIMIT_INDIVIDUAL_REACHED_DUE_TO_ENQUIRY: 'benefit-limit-individual-reached-due-to-enquiry',
    BENEFIT_LIMIT_INDIVIDUAL_REACHED_DUE_TO_CLAIMING: 'benefit-limit-individual-reached-due-to-claiming',
    BENEFIT_LIMIT_INDIVIDUAL_REDUCED_DUE_TO_ENQUIRY: 'benefit-limit-individual-reduced-due-to-enquiry',
    BENEFIT_LIMIT_INDIVIDUAL_REDUCED_DUE_TO_CLAIMING: 'benefit-limit-individual-reduced-due-to-claiming',
    SERVICE_LIMIT_POLICY_REACHED_DUE_TO_ENQUIRY: 'service-limit-policy-reached-due-to-enquiry',
    SERVICE_LIMIT_POLICY_REACHED_DUE_TO_CLAIMING: 'service-limit-policy-reached-due-to-claiming',
    SERVICE_LIMIT_POLICY_REDUCED_DUE_TO_ENQUIRY: 'service-limit-policy-reduced-due-to-enquiry',
    SERVICE_LIMIT_POLICY_REDUCED_DUE_TO_CLAIMING: 'service-limit-policy-reduced-due-to-claiming',
    BENEFIT_LIMIT_POLICY_REACHED_DUE_TO_ENQUIRY: 'benefit-limit-policy-reached-due-to-enquiry',
    BENEFIT_LIMIT_POLICY_REACHED_DUE_TO_CLAIMING: 'benefit-limit-policy-reached-due-to-claiming',
    BENEFIT_LIMIT_POLICY_REDUCED_DUE_TO_ENQUIRY: 'benefit-limit-policy-reduced-due-to-enquiry',
    BENEFIT_LIMIT_POLICY_REDUCED_DUE_TO_CLAIMING: 'benefit-limit-policy-reduced-due-to-claiming',
    BUNDLE_LIMIT_WILL_BE_REACHED: 'bundle-limit-will-be-reached',
    BUNDLE_LIMIT_HAS_BEEN_REACHED: 'bundle-limit-has-been-reached',
    LIFETIME_LIMIT_WILL_BE_REACHED: 'lifetime-limit-will-be-reached',
    LIFETIME_LIMIT_HAS_BEEN_REACHED: 'lifetime-limit-has-been-reached',
    ROLLING_LIMIT_WILL_BE_REACHED: 'rolling-limit-will-be-reached',
    ROLLING_LIMIT_HAS_BEEN_REACHED: 'rolling-limit-has-been-reached',
    UNKNOWN: 'unknown',
};
const BENEFIT_BACK_REASONABILITY_STATUS = {
    MUST_CLAIM_ITEM_WITH_ANOTHER: 'must-claim-item-with-another',
    CAN_NOT_CLAIM_ITEM_WITH_ANOTHER: 'can-not-claim-item-with-another',
    ONLY_ONE_CONSULTATION_PER_DAY: 'only-one-consultation-per-day',
    ONLY_ONE_SERVICE_PER_DAY: 'only-one-service-per-day',
    UNKNOWN_REASONABILITY: 'unknown-reasonability',
};
const PERK_TYPE = {
    DISCOUNT: 'discount',
    PARTNER_OFFER: 'partner-offer',
};
const STATEMENT_PRINT_MODE = {
    BATCH: 'batch',
    ONLINE: 'online',
};
const STATEMENT_REQUEST_TYPE = {
    PHIIB: 'PHIIB',
};
const STATEMENT_DELIVERY_MODE = {
    EMAIL: 'email',
    POSTAL: 'postal',
};
const WAITING_PERIOD_STATUS = {
    CLAIMABLE: 'claimable',
    CLAIMABLE_MIXED_END_DATE: 'claimable-mixed',
    MOSTLY_CLAIMABLE: 'mostly-claimable',
    NOT_CLAIMABLE_YET: 'not-claimable-yet',
    NOT_CLAIMABLE_MIXED_END_DATE: 'not-claimable-mixed',
    UNKNOWN: 'unknown',
};
const CUSTOMER_NEEDS = {
    ALL: 'all',
    BARE_BONES: 'bare-bones-cover',
    CHOOSABLE_EXTRAS: 'choosable-extras',
    DECIDE_EXTRAS_COVER: 'decide-extras-cover',
    EXTRAS_COVER: 'extras-cover',
    FAMILY: 'family-cover',
    FAMILY_FRIENDLY: 'family-friendly',
    HOSPITAL_COVER: 'hospital-cover',
    MID_LIFE: 'mid-life',
    OLDER: 'older',
    PACKAGE_COVER: 'hospital-extras-packages',
    PREGNANCY_COVER: 'pregnancy-cover',
    TAX: 'tax',
    YOUNG: 'young',
};
const NEEDS_PRODUCT_TYPE_SLUG = {
    AMBULANCE: 'ambulance',
    COMBINED: 'hospital-extras',
    EXTRAS: 'extras',
    HOSPITAL: 'hospital',
    PACKAGE: 'package',
};
const CUSTOMER_NEEDS_TITLES = {
    [CUSTOMER_NEEDS.ALL]: '',
    [CUSTOMER_NEEDS.BARE_BONES]: 'bare-bones',
    [CUSTOMER_NEEDS.CHOOSABLE_EXTRAS]: 'choosable extras',
    [CUSTOMER_NEEDS.EXTRAS_COVER]: 'extras cover',
    [CUSTOMER_NEEDS.HOSPITAL_COVER]: 'hospital cover',
    [CUSTOMER_NEEDS.PACKAGE_COVER]: 'hospital and extras packages',
    [CUSTOMER_NEEDS.FAMILY_FRIENDLY]: 'family friendly',
    [CUSTOMER_NEEDS.FAMILY]: 'family',
    [CUSTOMER_NEEDS.MID_LIFE]: 'mid-life',
    [CUSTOMER_NEEDS.OLDER]: 'older and wiser',
    [CUSTOMER_NEEDS.PREGNANCY_COVER]: 'pregnancy',
    [CUSTOMER_NEEDS.TAX]: 'to help at tax time',
    [CUSTOMER_NEEDS.YOUNG]: 'young and on the move',
    [NEEDS_PRODUCT_TYPE_SLUG.COMBINED]: 'hospital and extras cover',
    [NEEDS_PRODUCT_TYPE_SLUG.EXTRAS]: 'extras cover',
    [NEEDS_PRODUCT_TYPE_SLUG.HOSPITAL]: 'hospital cover',
    [NEEDS_PRODUCT_TYPE_SLUG.PACKAGE]: 'hospital and extras packages',
};
const getParentsOfProducts = (products, parentProducts) => (0, lodash_1.default)(products)
    .map((product) => (0, fp_1.findKey)((0, fp_1.includes)(product), parentProducts))
    .uniq()
    .compact()
    .value();
const CHOOSABLE_PRODUCTS_FOR_NEEDS = [
    { extras: PRODUCT.CHOOSABLE_50_TEETH },
    { extras: PRODUCT.CHOOSABLE_60_TEETH_EYES },
    { extras: PRODUCT.CHOOSABLE_60_TEETH_MUSCLE_BONE },
    { extras: PRODUCT.CHOOSABLE_60_TEETH_WELLBEING },
    { extras: PRODUCT.CHOOSABLE_60_TEETH_EYES_MUSCLE_BONE },
    { extras: PRODUCT.CHOOSABLE_60_TEETH_EYES_WELLBEING },
    { extras: PRODUCT.CHOOSABLE_60_TEETH_WELLBEING_MUSCLE_BONE },
    { extras: PRODUCT.CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE },
];
const PRODUCTS_BY_NEEDS = {
    // TODO: AP-1293 Remove ESSENTIALS_BASIC_PLUS and STARTER_BASIC after go live
    [CUSTOMER_NEEDS.BARE_BONES]: {
        [NEEDS_PRODUCT_TYPE_SLUG.COMBINED]: [
            { extras: PRODUCT.CHOOSABLE_50_TEETH, hospital: PARENT_PRODUCT.STARTER_BASIC },
            { extras: PRODUCT.CHOOSABLE_50_TEETH, hospital: PARENT_PRODUCT.ESSENTIALS_BASIC_PLUS },
            { extras: PRODUCT.CHOOSABLE_50_TEETH, hospital: PARENT_PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC },
            { extras: PRODUCT.CHOOSABLE_50_TEETH, hospital: PARENT_PRODUCT.CORE_HOSPITAL_BASIC_PLUS },
            { extras: PRODUCT.VALUE_EXTRAS, hospital: PARENT_PRODUCT.STARTER_BRONZE },
            { extras: PRODUCT.VALUE_EXTRAS, hospital: PARENT_PRODUCT.SIMPLE_BRONZE_PLUS },
        ],
        [NEEDS_PRODUCT_TYPE_SLUG.EXTRAS]: [
            { extras: PRODUCT.BLACK_50_SAVER_EXTRAS },
            { extras: PRODUCT.BLACK_60_EXTRAS },
            { extras: PRODUCT.BLACK_70_EXTRAS },
            { extras: PRODUCT.VALUE_EXTRAS },
            ...CHOOSABLE_PRODUCTS_FOR_NEEDS,
        ],
        [NEEDS_PRODUCT_TYPE_SLUG.HOSPITAL]: [
            { hospital: PARENT_PRODUCT.STARTER_BASIC },
            { hospital: PARENT_PRODUCT.ESSENTIALS_BASIC_PLUS },
            { hospital: PARENT_PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC },
            { hospital: PARENT_PRODUCT.CORE_HOSPITAL_BASIC_PLUS },
            { hospital: PARENT_PRODUCT.STARTER_BRONZE },
            { hospital: PARENT_PRODUCT.SIMPLE_BRONZE_PLUS },
        ],
    },
    [CUSTOMER_NEEDS.HOSPITAL_COVER]: {
        [CUSTOMER_NEEDS.ALL]: (0, fp_1.map)((product) => ({
            hospital: product,
        }), getParentsOfProducts(PRODUCT_BY_TYPE_DICT[PRODUCT_TYPE.HOSPITAL], PRODUCTS_BY_PARENT)),
    },
    [CUSTOMER_NEEDS.PACKAGE_COVER]: {
        [CUSTOMER_NEEDS.ALL]: (0, fp_1.map)((product) => ({
            package: product,
        }), getParentsOfProducts(PRODUCT_BY_TYPE_DICT[PRODUCT_TYPE.PACKAGE], PRODUCTS_BY_PARENT)),
    },
    [CUSTOMER_NEEDS.EXTRAS_COVER]: {
        [CUSTOMER_NEEDS.ALL]: (0, fp_1.map)((product) => ({
            extras: product,
        }), lodash_1.default.values(PRODUCT_BY_TYPE_DICT[PRODUCT_TYPE.EXTRAS])),
        [CUSTOMER_NEEDS.FAMILY_FRIENDLY]: [
            { extras: PRODUCT.BLACK_60_EXTRAS },
            { extras: PRODUCT.LIFESTYLE_EXTRAS },
            { extras: PRODUCT.FAMILY_EXTRAS },
            { extras: PRODUCT.BLACK_70_BOOST_EXTRAS },
            { extras: PRODUCT.SUPER_EXTRAS },
        ],
        [CUSTOMER_NEEDS.MID_LIFE]: [
            { extras: PRODUCT.BLACK_60_EXTRAS },
            { extras: PRODUCT.BLACK_70_EXTRAS },
            { extras: PRODUCT.LIFESTYLE_EXTRAS },
            { extras: PRODUCT.BLACK_70_BOOST_EXTRAS },
            ...CHOOSABLE_PRODUCTS_FOR_NEEDS,
        ],
        [CUSTOMER_NEEDS.OLDER]: [
            { extras: PRODUCT.BLACK_60_EXTRAS },
            { extras: PRODUCT.LIFESTYLE_EXTRAS },
            { extras: PRODUCT.BLACK_70_BOOST_EXTRAS },
            { extras: PRODUCT.SUPER_EXTRAS },
        ],
        [CUSTOMER_NEEDS.YOUNG]: [
            { extras: PRODUCT.BLACK_50_SAVER_EXTRAS },
            { extras: PRODUCT.BLACK_60_EXTRAS },
            { extras: PRODUCT.VALUE_EXTRAS },
            { extras: PRODUCT.LIFESTYLE_EXTRAS },
            ...CHOOSABLE_PRODUCTS_FOR_NEEDS,
        ],
    },
    [CUSTOMER_NEEDS.FAMILY]: {
        [NEEDS_PRODUCT_TYPE_SLUG.COMBINED]: [
            { extras: PRODUCT.BLACK_60_EXTRAS, hospital: PARENT_PRODUCT.SIMPLE_BRONZE_PLUS },
            { extras: PRODUCT.FAMILY_EXTRAS, hospital: PARENT_PRODUCT.ESSENTIALS_SILVER_PLUS },
            { extras: PRODUCT.VALUE_EXTRAS, hospital: PARENT_PRODUCT.STARTER_BRONZE },
        ],
        [NEEDS_PRODUCT_TYPE_SLUG.HOSPITAL]: [
            { hospital: PARENT_PRODUCT.SIMPLE_BRONZE_PLUS },
            { hospital: PARENT_PRODUCT.CORE_BRONZE_PLUS },
            { hospital: PARENT_PRODUCT.ESSENTIALS_SILVER_PLUS },
            { hospital: PARENT_PRODUCT.CORE_SILVER_PLUS },
        ],
        [NEEDS_PRODUCT_TYPE_SLUG.EXTRAS]: [
            { extras: PRODUCT.BLACK_60_EXTRAS },
            { extras: PRODUCT.LIFESTYLE_EXTRAS },
            { extras: PRODUCT.FAMILY_EXTRAS },
            { extras: PRODUCT.BLACK_70_BOOST_EXTRAS },
            { extras: PRODUCT.SUPER_EXTRAS },
        ],
    },
    [CUSTOMER_NEEDS.PREGNANCY_COVER]: {
        [NEEDS_PRODUCT_TYPE_SLUG.COMBINED]: [
            // TODO Remove Top Hospital Gold after Advanced Hospital Gold goes live (part of clean up card ART-1615)
            { hospital: PARENT_PRODUCT.TOP_HOSPITAL_GOLD },
            { extras: PRODUCT.FAMILY_EXTRAS, hospital: PARENT_PRODUCT.TOP_HOSPITAL_GOLD },
            { extras: PRODUCT.SUPER_EXTRAS, hospital: PARENT_PRODUCT.TOP_HOSPITAL_GOLD },
            { hospital: PARENT_PRODUCT.ADVANCED_HOSPITAL_GOLD },
            { extras: PRODUCT.FAMILY_EXTRAS, hospital: PARENT_PRODUCT.ADVANCED_HOSPITAL_GOLD },
            { extras: PRODUCT.SUPER_EXTRAS, hospital: PARENT_PRODUCT.ADVANCED_HOSPITAL_GOLD },
        ],
        [NEEDS_PRODUCT_TYPE_SLUG.EXTRAS]: [{ extras: PRODUCT.SUPER_EXTRAS }, { extras: PRODUCT.FAMILY_EXTRAS }],
    },
    [CUSTOMER_NEEDS.TAX]: {
        [NEEDS_PRODUCT_TYPE_SLUG.HOSPITAL]: [
            { hospital: PARENT_PRODUCT.STARTER_BASIC },
            { hospital: PARENT_PRODUCT.ESSENTIALS_BASIC_PLUS },
            { hospital: PARENT_PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC },
            { hospital: PARENT_PRODUCT.CORE_HOSPITAL_BASIC_PLUS },
            { hospital: PARENT_PRODUCT.STARTER_BRONZE },
            { hospital: PARENT_PRODUCT.LITE_BRONZE_PLUS },
        ],
    },
};
const ARCHIVE_SOURCE = {
    COMPUTERSHARE: 'computershare',
};
const NOMINATION_HISTORY_STATUS = {
    DELETED: 'deleted',
    EXPIRED: 'expired',
    FORCE_PAID: 'force-paid',
    INELIGIBLE: 'ineligible',
    LINKED: 'linked',
    PAID: 'paid',
    PENDING: 'pending',
};
const REFER_A_FRIEND_OFFER_ID = {
    FRIEND: 'friend',
    REFER: 'refer',
};
const OFFER_CODE_TYPE = {
    PROMO: 'promo',
    REFERRAL: 'referral',
};
const MFA_STATUS = {
    FAILURE: 'failure',
    SUCCESS: 'success',
};
const LEAD_SOURCE_TYPES = {
    ABANDONED_CART: 'ahm-web-buy-form-capture',
    REQUEST_A_CALL: 'website',
    SAVE_AND_RETRIEVE_QUOTE: 'ahm-web-save-cover',
    ABANDONED_CART_PRE_BUY_FORM: 'ahm-web-pre-buy-form',
};
const TARGET_SEGMENT = {
    FRIEND_LOOKING_FOR_PRIVATE_HEALTH_INSURANCE: 'friend-looking-for-private-health-insurance',
    LOOKING_FOR_PRIVATE_HEALTH_INSURANCE: 'looking-for-private-health-insurance',
    PARTNER_LOOKING_FOR_PRIVATE_HEALTH_INSURANCE: 'partner-looking-for-private-health-insurance',
};
const PAYMENT_STATE = {
    ACTIVE: 'active',
    INVALID: 'invalid',
    PAUSED: 'paused',
};
const HOSPITAL_COVER_CHECK_OUTCOMES = {
    ASSESSING: 'assessing',
    ELIGIBLE: 'eligible',
    NOT_ELIGIBLE: 'not eligible',
};
const PICC_MEMBER_VALIDATION_STATUS = {
    MISSING_REQUIRED_FIELDS: 'missing-required-fields',
    DUPLICATE_VALIDATION_FOUND: 'duplicate-validation-found',
    VALIDATION_FAILED: 'validation-failed',
    CONSENT_OBTAINED: 'consent-obtained',
    INTERNAL_SERVER_ERROR: 'internal-server-error',
    INVALID_DATE_FORMAT: 'invalid-date-format',
    AGE_MISMATCH: 'age-mismatch',
};
const PICC_AUTHORITY_TYPE = {
    AUTHORISED_PERSON: 'A',
    PICC: 'C',
    PARTNER_AUTHORITY: 'P',
    REPLACEMENT_POLICY_HOLDER: 'R',
};
const COMMON_ACCEPTED_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
const MEMBERSHIP_SUSPENSION_REASON = {
    FINANCIAL_HARDSHIP: 'Financial Hardship CV Suspension - Whole Mbrship',
    OVERSEAS: 'Overseas Suspension - Whole Membership',
};
const TRANSFER_TYPE_BY_WHICS_TRANSFER_TYPE_ID = {
    AD: 'adjust and write off',
    AP: 'agent payment',
    AR: 'agency return',
    BO: 'refer a friend reward',
    BP: 'bpay payment',
    CA: 'claims adjustments',
    CB: 'claims recover full bpay',
    CD: 'claims recover full dire',
    CH: 'manual payment',
    CR: 'claims recover full pway',
    CV: 'cover change',
    DB: 'direct debit',
    DC: 'dishonoured cheque',
    DD: 'direct debit dishonour',
    DJ: 'date joined modifier',
    DM: 'date paid modifier',
    GP: 'group deductions',
    JN: 'journals',
    LH: 'lhc loading removed',
    LR: 'lodge receipt',
    MO: 'oshc comp mig payment',
    MS: 'oshc comp mig refund',
    OS: 'oshc payment',
    PB: 'partial bpay recovery',
    PD: 'partial direct recovery',
    PP: 'partial payway recovery',
    RC: 'reissue cheque',
    RD: 'reissue direct credit',
    RO: 'reissue refer a fnd chq',
    RU: 'resumption health policy',
    SO: 're-issue refer a friend',
    SR: 'system refund',
    SS: 'reissue refund',
    ST: 'oshc credit adjustment',
    SU: 'health policy suspension',
    TP: 'travel receipt',
    TV: 'travel policy',
    WC: 'workers compensation',
};
/* @ts-expect-error: lodash/fp hasn't typed map to include convert */
const TRANSFER_TYPES = fp_1.mapKeys.convert({ cap: false })((value) => (0, fp_1.toUpper)((0, fp_1.snakeCase)(value)), TRANSFER_TYPE_BY_WHICS_TRANSFER_TYPE_ID);
module.exports = {
    ADDRESS_STATE,
    AGR_TABLE,
    AHM_SOURCE_CODE,
    ANALYTICS,
    ARCHIVE_SOURCE,
    AUTHORISED_PERSON_RELATIONSHIP,
    BENEFIT_BACK_LIMIT_DATES,
    BENEFIT_BACK_REASONABILITY_STATUS,
    BENEFIT_BACK_REASONABILITY_TYPE,
    BENEFIT_BACK_STATUS,
    CHANGE_COVER_CAMPAIGN_CODE,
    CHANGE_COVER_PROMO_CODE,
    CHOOSABLE_PRODUCTS_FOR_NEEDS,
    CLAIM_ITEM_STATUS,
    CLAIM_ITEM_TYPE,
    CLAIM_ITEMS_LIMIT,
    CLAIM_METHOD_BY_DISPLAY,
    CLAIM_PAYMENT_STATUS,
    CLAIM_STATUS,
    CLAIM_TYPE,
    CLAIMS_HISTORY,
    COMBINED_PARENT_PRODUCT_COMPONENTS,
    COMBINED_PRODUCT_COMPONENTS,
    COMMON_ACCEPTED_MIME_TYPES,
    CONDITION_CODE_DESCRIPTION,
    CONDITION_CODE_ITEMS,
    CONDITION_CODE,
    CONDITIONS,
    CONSENT_STATUS,
    CONTACT,
    CREDIT_CARD_TYPE,
    CUSTOMER_NEEDS_TITLES,
    CUSTOMER_NEEDS,
    DATE_FORMAT,
    DENTAL_SERVICE_IDS,
    DIRECT_DEBIT_TYPE,
    ENROL_CODE,
    ENROL_TYPE_BY_CODE,
    EXPRESS_CONSENT_STATUS,
    EXTRAS_TYPE,
    FEATURE,
    FUND,
    GENDER,
    GENERIC_PROVIDER_FOR_SERVICE_OR_SERVICE_ITEM_GROUP,
    GENERIC_PROVIDER,
    HEALTH_FUND,
    HEALTH_POLICY_STATUS,
    HIF_STATUS,
    HIF_SUPPORTING_DOCUMENT_TYPE,
    HOSPITAL_COVER_CHECK_OUTCOMES,
    HOSPITAL_PRODUCT_TIER,
    INCOME_TIER,
    INCOME_TYPE,
    LEAD_SOURCE_TYPES,
    LIFE_INSURANCE,
    LIFE_STAGE,
    LIVE_CHAT_STATUS,
    MEDICARE_CARD_COLOUR,
    MEMBER_STATUS,
    MEMBERSHIP_SUSPENSION_REASON,
    MFA_STATUS,
    NEEDS_PRODUCT_TYPE_SLUG,
    NOMINATION_HISTORY_STATUS,
    NOTIFY_METHOD,
    OFFER_CODE_TYPE,
    OFFER_GROUP,
    PARENT_PRODUCT_BY_TYPE,
    PARENT_PRODUCT,
    PAYMENT_FREQUENCY_DURATION,
    PAYMENT_FREQUENCY,
    PAYMENT_METHOD,
    PAYMENT_STATE,
    PERK_TYPE,
    PICC_AUTHORITY_TYPE,
    PICC_MEMBER_VALIDATION_STATUS,
    PMOC_CATEGORY,
    PMOC_CHANNEL_MARKETING,
    PMOC_CHANNEL_SMS,
    PMOC_CHANNEL,
    PRODUCT_BY_TYPE_DICT,
    PRODUCT_FETCH_TYPE,
    PRODUCT_ITEM_CATEGORY,
    PRODUCT_LIMIT_CATEGORY,
    PRODUCT_TYPE_SLUG,
    PRODUCT_TYPE,
    PRODUCT,
    PRODUCTS_BY_NEEDS,
    PRODUCTS_BY_PARENT,
    PRODUCTS_BY_TYPE,
    PROMO_CODE,
    PROVIDER_OCCUPATIONS,
    PROVIDER_TYPE,
    RATE_CODE_VALUE,
    RATE_CODE,
    RATE_TYPE,
    REBATE_AGE_BRACKET,
    REBATE_OPTION,
    REDIRECT_TYPE,
    REFER_A_FRIEND_OFFER_ID,
    REFORM_CHANGE_LEVELS,
    RELATIONSHIP,
    RESET_INDICATOR,
    SCALE,
    SERVICE_ITEM_GROUP,
    SERVICE_ITEM,
    SERVICE_TYPE,
    SERVICE,
    SMS_CONTACT_CATEGORY_TYPE,
    SMS_CONTACT_CATEGORY,
    STATE,
    STATEMENT_DELIVERY_MODE,
    STATEMENT_PRINT_MODE,
    STATEMENT_REQUEST_TYPE,
    SURCHARGE_INDICATOR,
    SURCHARGE_PERCENTAGE,
    SUSPENDED_CLAIM_STATUS,
    TARGET_SEGMENT,
    TITLE,
    TRANSFER_TYPE_BY_WHICS_TRANSFER_TYPE_ID,
    TRANSFER_TYPES,
    UI: ui_1.default,
    UPLOAD_DOCUMENT_TYPES,
    USER_TYPE,
    VIEW_MODE,
    WAITING_PERIOD_STATUS,
    WEB_VIEW_COOKIE,
    WHITELIST: whitelist_1.default,
};
